import * as React from "react"
import { SVGProps } from "react"
const MyAssignedDevicesCountAnimated = (props: SVGProps<SVGSVGElement>) => (
  <svg
    className="animated"
    id="freepik_stories-cardiologist"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 500 500"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
    width={250}
    height={250}
  >
    <style>
      {
        "svg#freepik_stories-cardiologist:not(.animated) .animable {opacity: 0;}svg#freepik_stories-cardiologist.animated #freepik--Heartbeats--inject-408 {animation: 1.7s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight;animation-delay: 0s;}svg#freepik_stories-cardiologist.animated #freepik--Character--inject-408 {animation: 6s Infinite  linear heartbeat;animation-delay: 0s;}            @keyframes slideRight {                0% {                    opacity: 0;                    transform: translateX(30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes heartbeat {                0% {                    transform: scale(1);                }                10% {                    transform: scale(1.1);                }                30% {                    transform: scale(1);                }                40% {                    transform: scale(1);                }                50% {                    transform: scale(1.1);                }                60% {                    transform: scale(1);                }                100% {                    transform: scale(1);                }            }"
      }
    </style>
    <g
      id="freepik--Floor--inject-408"
      style={{
        transformOrigin: "245.025px 479.4px 0px",
      }}
      className="animable"
    >
      <path
        d="M453.05,479.4c0,.15-93.16.26-208,.26S37,479.55,37,479.4s93.14-.26,208.06-.26S453.05,479.26,453.05,479.4Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "245.025px 479.4px 0px",
        }}
        id="el17q5ox7effl"
        className="animable"
      />
    </g>
    <g
      id="freepik--Plants--inject-408"
      style={{
        transformOrigin: "72.2585px 420.25px 0px",
      }}
      className="animable"
    >
      <path
        d="M65.3,443.8S46.71,422.4,39.7,401,36,382.07,36,382.07s9.46,20.78,16.65,30.82,20,24.77,20,24.77Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "53.9346px 412.892px 0px",
        }}
        id="eltp1la1pb9z"
        className="animable"
      />
      <path
        d="M69,385.41a1.08,1.08,0,0,0-2,.68c1.13,7.52,3.58,25.15,3.48,36.59-.12,14.86,0,20.6,0,20.6h7.73s-1.37-30.71-3.12-40.08A63.87,63.87,0,0,0,69,385.41Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "72.6013px 414.082px 0px",
        }}
        id="elo2p9dmeuowq"
        className="animable"
      />
      <path
        d="M73.22,440.78a81.84,81.84,0,0,0,6.37-23.09c.64-5.47-.5-12.86-2.19-22.73a60.74,60.74,0,0,1-1-10.93,1.85,1.85,0,0,1,3.47-.87c.93,1.67,3.63,7.36,4.32,10.93,1.87,9.74,4,14.61,2.37,23.85S79,441.41,79,441.41Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "80.1802px 411.806px 0px",
        }}
        id="el8hprsl9na2"
        className="animable"
      />
      <path
        d="M80.19,441.41S100.6,397.55,102,391s6.22-21.49,6.79-20.65,1.41,8.77-2.26,17.83-19.38,54.52-19.38,54.52h-7"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "94.7239px 406.508px 0px",
        }}
        id="el1ystf180bihg"
        className="animable"
      />
      <path
        d="M71,439.45a4.86,4.86,0,0,1-.58-.4c-.36-.27-.91-.66-1.58-1.2A71.11,71.11,0,0,1,63.35,433a91.7,91.7,0,0,1-14.81-19,124.61,124.61,0,0,1-10.1-21.89c-1-2.91-1.78-5.3-2.26-6.95-.25-.83-.43-1.48-.55-1.92a3.84,3.84,0,0,1-.15-.67,5.71,5.71,0,0,1,.24.65c.15.47.36,1.1.62,1.89.53,1.63,1.33,4,2.39,6.89a132,132,0,0,0,10.19,21.78,95.75,95.75,0,0,0,14.64,19c2.19,2.18,4.06,3.83,5.38,4.93.65.57,1.18,1,1.53,1.27A3.08,3.08,0,0,1,71,439.45Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "53.24px 411.01px 0px",
        }}
        id="el6dtrf0iafo"
        className="animable"
      />
      <path
        d="M73.22,418.41a7.91,7.91,0,0,1-.18-1.29c-.1-.91-.23-2.09-.38-3.52-.32-3-.83-7.06-1.55-11.55s-1.53-8.54-2.15-11.46l-.74-3.45a7,7,0,0,1-.23-1.28,7.86,7.86,0,0,1,.39,1.23c.23.81.53,2,.88,3.43.7,2.91,1.56,7,2.28,11.46s1.18,8.61,1.43,11.59c.12,1.49.2,2.7.23,3.54A7.63,7.63,0,0,1,73.22,418.41Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "70.6143px 402.135px 0px",
        }}
        id="elrqxaqj4j1o"
        className="animable"
      />
      <path
        d="M78,382.82a3.11,3.11,0,0,1,.24.56c.15.41.36.95.61,1.63s.58,1.57.88,2.61.69,2.19,1,3.51l.5,2.06c.18.72.3,1.48.45,2.26.34,1.56.54,3.24.79,5A81.39,81.39,0,0,1,83,412.09a82.63,82.63,0,0,1-1.32,11.56c-.37,1.75-.7,3.42-1.14,5-.22.76-.39,1.51-.61,2.22l-.66,2c-.38,1.29-.86,2.42-1.24,3.43s-.74,1.86-1.06,2.54l-.72,1.58a3.3,3.3,0,0,1-.28.54,2.25,2.25,0,0,1,.2-.57c.16-.41.38-.95.65-1.61s.64-1.55,1-2.57.8-2.14,1.17-3.44c.2-.64.41-1.32.62-2s.38-1.45.59-2.21c.42-1.53.73-3.19,1.1-4.94a85.11,85.11,0,0,0,1.27-11.5,84,84,0,0,0-.45-11.56c-.23-1.76-.42-3.44-.74-5-.15-.77-.26-1.53-.42-2.25s-.33-1.4-.48-2.06c-.27-1.32-.65-2.48-.93-3.51s-.55-1.92-.8-2.63-.4-1.23-.53-1.65A2.65,2.65,0,0,1,78,382.82Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "79.4989px 411.89px 0px",
        }}
        id="elrk8dmydqmnb"
        className="animable"
      />
      <path
        d="M108.57,371.28a1.42,1.42,0,0,1,0,.19c0,.16,0,.34-.09.57-.09.5-.2,1.24-.4,2.18-.4,1.89-1,4.61-2.07,7.9s-2.41,7.16-4.07,11.4-3.56,8.87-5.37,13.8S93.29,417,92,421.39s-2.57,8.27-3.78,11.49a73.5,73.5,0,0,1-3.22,7.5c-.42.87-.8,1.52-1,2l-.28.5-.11.16s0-.06.07-.18.14-.32.24-.52c.22-.46.57-1.12,1-2,.82-1.74,1.92-4.29,3.08-7.53s2.39-7.15,3.69-11.51,2.72-9.17,4.56-14.1,3.74-9.56,5.41-13.79,3.09-8.08,4.14-11.35,1.76-6,2.2-7.84c.23-.94.37-1.67.48-2.16.06-.23.1-.41.14-.57S108.56,371.27,108.57,371.28Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "96.1198px 407.16px 0px",
        }}
        id="eln72kux9ba1d"
        className="animable"
      />
      <path
        d="M45.64,361.59a1.76,1.76,0,0,0-2.9,1.79A49.52,49.52,0,0,0,45.31,370c2.8,6,11,27.36,14.9,39.11s9.3,33.66,9.3,33.66l8.24-1.33s-7.54-36-14.91-49C56.93,382,51,366.93,45.64,361.59Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "60.2056px 401.935px 0px",
        }}
        id="el28j3fhadhf7"
        className="animable"
      />
      <path
        d="M62.47,416.43a4.65,4.65,0,0,1,.42,1c.25.65.58,1.59,1,2.77.76,2.35,1.69,5.63,2.63,9.28s1.71,7,2.25,9.37c.24,1.14.45,2.09.62,2.85a5.84,5.84,0,0,1,.17,1.06,4.68,4.68,0,0,1-.34-1l-.75-2.82L66,429.56c-.93-3.64-1.81-6.93-2.49-9.29-.33-1.12-.6-2.06-.82-2.8A5.5,5.5,0,0,1,62.47,416.43Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "66.015px 429.595px 0px",
        }}
        id="elgybdrcq1jpu"
        className="animable"
      />
      <path
        d="M73.65,442.08a.63.63,0,0,1-.05-.22c0-.18-.06-.39-.09-.65-.09-.57-.17-1.42-.34-2.5-.3-2.16-.84-5.28-1.73-9.08a130.11,130.11,0,0,0-3.85-13.16c-1.69-4.89-3.81-10.16-6.22-15.62-4.84-10.9-9.68-20.57-12.86-27.72-1.61-3.57-2.86-6.48-3.68-8.51-.42-1-.72-1.8-.92-2.34-.1-.25-.17-.45-.23-.61s-.07-.22-.07-.22a.74.74,0,0,1,.11.2l.27.6c.24.56.57,1.33,1,2.31.87,2,2.15,4.89,3.8,8.44,3.25,7.11,8.13,16.76,13,27.68,2.41,5.46,4.52,10.75,6.19,15.65a122.36,122.36,0,0,1,3.78,13.23,91.77,91.77,0,0,1,1.6,9.13c.14,1.09.19,1.94.25,2.51,0,.26,0,.48,0,.65S73.65,442.08,73.65,442.08Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "58.63px 401.765px 0px",
        }}
        id="elticz0rbgncj"
        className="animable"
      />
      <path
        d="M77.75,441.41a8.61,8.61,0,0,1-.28-1.39c-.17-1-.38-2.24-.64-3.78-.57-3.19-1.44-7.59-2.68-12.38s-2.63-9.05-3.7-12.11c-.52-1.47-1-2.69-1.29-3.61a8.71,8.71,0,0,1-.43-1.35,11.88,11.88,0,0,1,.59,1.28c.36.84.85,2.06,1.42,3.58a119.43,119.43,0,0,1,3.83,12.1,126.21,126.21,0,0,1,2.56,12.44c.23,1.6.41,2.91.51,3.81A10.25,10.25,0,0,1,77.75,441.41Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "73.24px 424.1px 0px",
        }}
        id="elk7ysnjnv8bg"
        className="animable"
      />
      <rect
        x={62.5}
        y={440.22}
        width={32.15}
        height={39.18}
        style={{
          fill: "rgb(255, 114, 94)",
          transformOrigin: "78.575px 459.81px 0px",
        }}
        id="el62ocv3o5gns"
        className="animable"
      />
      <g id="elxqnpglhdo1h">
        <g
          style={{
            opacity: 0.3,
            transformOrigin: "78.575px 459.81px 0px",
          }}
          className="animable"
        >
          <rect
            x={62.5}
            y={440.22}
            width={32.15}
            height={39.18}
            id="elsuymefgaqn8"
            style={{
              transformOrigin: "78.575px 459.81px 0px",
            }}
            className="animable"
          />
        </g>
      </g>
      <rect
        x={55.87}
        y={440.22}
        width={28.53}
        height={39.18}
        style={{
          fill: "rgb(255, 114, 94)",
          transformOrigin: "70.135px 459.81px 0px",
        }}
        id="ell5tvc3kft4e"
        className="animable"
      />
    </g>
    <g
      id="freepik--speech-bubble--inject-408"
      style={{
        transformOrigin: "65.6158px 96.4362px 0px",
      }}
      className="animable"
    >
      <path
        d="M96.07,119.54l-9.4-1.31A30.4,30.4,0,1,1,93,109.38h0Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "65.5885px 96.4037px 0px",
        }}
        id="elhg3eoq18w88"
        className="animable"
      />
      <path
        d="M96.07,119.54s-.08-.23-.21-.67-.35-1.1-.62-2c-.53-1.72-1.32-4.24-2.34-7.52l.17,0h0a.1.1,0,0,1-.14,0,.09.09,0,0,1,0-.11,30.32,30.32,0,0,0,2.78-14.66A28.2,28.2,0,0,0,95,90.06a32.66,32.66,0,0,0-1.5-4.76,30.08,30.08,0,0,0-57.64,6.59A30.71,30.71,0,0,0,37,105.69a29.61,29.61,0,0,0,6.6,11.25,30.23,30.23,0,0,0,20.49,9.59l1.29,0a9,9,0,0,0,1.27,0l2.47-.16a44.44,44.44,0,0,0,4.62-.91,30.13,30.13,0,0,0,12.89-7.34.08.08,0,0,1,.08,0l7,1,1.81.27.62.1-.59-.07-1.79-.23-7-.93.08,0a30.26,30.26,0,0,1-13,7.48,42,42,0,0,1-4.65.93l-2.5.18a9.09,9.09,0,0,1-1.28,0L64,126.85a30.42,30.42,0,0,1-20.75-9.65,29.94,29.94,0,0,1-6.71-11.38,31,31,0,0,1-1.1-14,30.27,30.27,0,0,1,5.67-13.55,14.64,14.64,0,0,1,1.15-1.45l1.2-1.39,1.33-1.26A12,12,0,0,1,46.19,73l1.42-1.12c.47-.39,1-.66,1.5-1s1-.67,1.52-.95l1.59-.81A30,30,0,0,1,65.62,66,30.56,30.56,0,0,1,88,75.89a30,30,0,0,1,5.81,9.29A32.42,32.42,0,0,1,95.33,90a30.18,30.18,0,0,1-2.26,19.43l-.16-.1h0a.09.09,0,0,1,.13,0,.08.08,0,0,1,0,0L95.33,117c.25.85.43,1.49.57,1.94S96.07,119.54,96.07,119.54Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "65.6158px 96.4362px 0px",
        }}
        id="el5j3ca142ybo"
        className="animable"
      />
      <polygon
        points="51.55 97.27 55.78 92.59 64.75 99.8 78.08 84.49 82.44 88.74 64.55 108.42 51.55 97.27"
        style={{
          fill: "rgb(255, 114, 94)",
          transformOrigin: "66.995px 96.455px 0px",
        }}
        id="elhfmyxha2u2f"
        className="animable"
      />
    </g>
    <g
      id="freepik--Heartbeats--inject-408"
      style={{
        transformOrigin: "337.34px 385.255px 0px",
      }}
      className="animable animator-active"
    >
      <rect
        x={224.38}
        y={380.95}
        width={226.02}
        height={61.78}
        rx={5.89}
        style={{
          fill: "rgb(250, 250, 250)",
          transformOrigin: "337.39px 411.84px 0px",
        }}
        id="el41tcscxghsb"
        className="animable"
      />
      <path
        d="M444.51,442.73a8,8,0,0,0,1.44-.22,5.8,5.8,0,0,0,4.37-5.33c0-1.15,0-2.43,0-3.81,0-2.75,0-5.93,0-9.5,0-7.16,0-15.91,0-26.07q0-3.81,0-7.89c0-.67,0-1.36,0-2.05a10.76,10.76,0,0,0-.1-2.05,5.75,5.75,0,0,0-2.09-3.46,5.82,5.82,0,0,0-4-1.23H430.19l-199.9.08A5.65,5.65,0,0,0,225,385a10.17,10.17,0,0,0-.32,3.51v46.06a23.48,23.48,0,0,0,.11,3.38,5.61,5.61,0,0,0,4.35,4.4,20.4,20.4,0,0,0,3.34.12h39.39l89.88.05,60.59.08,16.47.05,4.28,0,1.46,0-1.46,0-4.28,0-16.47.05-60.59.08-89.88.06H232.44a20,20,0,0,1-3.44-.14,6.16,6.16,0,0,1-3.09-1.68,6.22,6.22,0,0,1-1.66-3.1,22.89,22.89,0,0,1-.12-3.49q0-13.81,0-28.08v-19.8a5.93,5.93,0,0,1,.34-1.86,6.17,6.17,0,0,1,5.82-4.14l199.9.08h13.87a6.2,6.2,0,0,1,4.2,1.31,6,6,0,0,1,2.2,3.67,11.49,11.49,0,0,1,.1,2.1v2.05q0,4.08,0,7.89c0,10.16,0,18.91-.05,26.07,0,3.57,0,6.75,0,9.5,0,1.38,0,2.65,0,3.82a5.9,5.9,0,0,1-4.49,5.38,5,5,0,0,1-1.08.15Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "337.34px 411.705px 0px",
        }}
        id="el66ji01r1szk"
        className="animable"
      />
      <path
        d="M429.78,417.22l-.7,0-2.05,0-7.87.05-12.46.05a3.18,3.18,0,0,1-1.86-.43,3,3,0,0,1-.74-.68c-.2-.27-.34-.56-.51-.84l-2-3.47c-.35-.6-.69-1.2-1.05-1.81a5,5,0,0,0-1.21-1.68,2.53,2.53,0,0,0-1.95-.43,2.48,2.48,0,0,0-1.67,1.19L385,426.09a3,3,0,0,1-2.28,1.63,2.86,2.86,0,0,1-2.64-1.11c-1-1.63-1.88-3.26-2.85-4.92l-5.86-10.26-6.16-10.78-1.58-2.77a2.43,2.43,0,0,0-2.38-1.41,2.33,2.33,0,0,0-1.34.53,7.66,7.66,0,0,0-1,1.2l-2,2.63-8,10.74-4.13,5.5a3,3,0,0,1-1.61.94,12.22,12.22,0,0,1-1.79.07H329.15a15.2,15.2,0,0,1-1.76-.05,2.9,2.9,0,0,1-1.62-.89c-.4-.48-.7-.91-1.06-1.37l-4.1-5.38-.51-.66a2.46,2.46,0,0,0-.55-.52,2.38,2.38,0,0,0-1.42-.41,2.5,2.5,0,0,0-1.4.49,4.26,4.26,0,0,0-.94,1.23l-6.83,11-1.67,2.68-.83,1.33a10.28,10.28,0,0,1-.89,1.33,2.9,2.9,0,0,1-3.1.74,2.77,2.77,0,0,1-1.32-1c-.33-.46-.54-.88-.81-1.32l-11.72-19.74L285.91,401l-1.31-2.21a6.27,6.27,0,0,0-1.42-2,2.48,2.48,0,0,0-2.19-.32,2.24,2.24,0,0,0-.95.59,9.78,9.78,0,0,0-.72.92l-2.76,3.8-9.72,13.34-1.06,1.44a2.81,2.81,0,0,1-1.37,1.13,4.09,4.09,0,0,1-1.68.2h-1.6l-5.69,0-7.87-.05-2,0-.7,0,.7,0,2,0,7.87-.05,5.69,0h1.6a4,4,0,0,0,1.59-.19,2.65,2.65,0,0,0,1.24-1l1-1.45c2.85-3.94,6.08-8.43,9.66-13.39.89-1.24,1.81-2.5,2.75-3.8a9.14,9.14,0,0,1,.75-1,2.83,2.83,0,0,1,3.65-.32,3,3,0,0,1,.89,1l.65,1.09c.44.73.88,1.46,1.32,2.21l2.72,4.55,11.76,19.72c.26.42.51.9.78,1.27a2.36,2.36,0,0,0,1.11.81,2.41,2.41,0,0,0,2.57-.63,10.45,10.45,0,0,0,.84-1.25l.82-1.33,1.66-2.69,6.83-11a4.61,4.61,0,0,1,1.06-1.36,2.94,2.94,0,0,1,1.69-.6,2.89,2.89,0,0,1,1.73.5,2.78,2.78,0,0,1,.66.62l.52.67,4.1,5.38c.34.43.7.93,1,1.33a2.44,2.44,0,0,0,1.33.73c.49.07,1.11,0,1.67,0h12.17a11.38,11.38,0,0,0,1.68-.06,2.35,2.35,0,0,0,1.32-.77l4.12-5.47q4.08-5.46,8.05-10.73l2-2.63a8,8,0,0,1,1.09-1.3,2.92,2.92,0,0,1,3.32-.24,3.21,3.21,0,0,1,1.16,1.27l1.58,2.77,6.14,10.79,5.84,10.27c1,1.65,1.88,3.34,2.8,4.88a2.44,2.44,0,0,0,2.24.94,2.58,2.58,0,0,0,2-1.42L395.39,409a2.85,2.85,0,0,1,1.91-1.35,2.89,2.89,0,0,1,2.23.51,3,3,0,0,1,.76.86l.54.93c.35.61.69,1.22,1,1.82l2,3.48a3.28,3.28,0,0,0,1.14,1.41,2.86,2.86,0,0,0,1.7.4l12.46,0,7.87.05,2.05,0Z"
        style={{
          fill: "rgb(255, 114, 94)",
          transformOrigin: "337.325px 411.913px 0px",
        }}
        id="elby2m9ouxe5h"
        className="animable"
      />
      <line
        x1={396.3}
        y1={380.95}
        x2={374.49}
        y2={330.55}
        style={{
          fill: "rgb(250, 250, 250)",
          transformOrigin: "385.395px 355.75px 0px",
        }}
        id="elnyp2wnptxl9"
        className="animable"
      />
      <path
        d="M374.49,330.55c.13-.06,5.12,11.18,11.14,25.09s10.8,25.25,10.67,25.31-5.12-11.18-11.14-25.1S374.36,330.6,374.49,330.55Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "385.395px 355.75px 0px",
        }}
        id="elzqyjlosbzi"
        className="animable"
      />
      <path
        d="M377.16,330.37a2.72,2.72,0,1,1-2.72-2.72A2.72,2.72,0,0,1,377.16,330.37Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "374.44px 330.37px 0px",
        }}
        id="elxn1nbsy9qa"
        className="animable"
      />
    </g>
    <g
      id="freepik--Character--inject-408"
      style={{
        transformOrigin: "266.284px 268.19px 0px",
      }}
      className="animable"
    >
      <path
        d="M206.94,148.69a22.93,22.93,0,0,1,9.41,10.12c3.37,7.11,8.25,23.5,8.25,23.5l15-33.62,16.93,6.47s-19.21,47.77-22.67,53.49c-8.78,14.51-20.3,13.18-23.57,1.48S206.94,148.69,206.94,148.69Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "231.735px 183.954px 0px",
        }}
        id="elzob60dhs81o"
        className="animable"
      />
      <path
        d="M303.86,76.46A58.47,58.47,0,0,0,297.43,75c-3.58-.53-3.23-3.43-3.23-3.43a99.05,99.05,0,0,0,.13-11.64l-21.67-.8C272.51,69.23,269,83.35,260.59,105s-18.28,15.23-32.42,37.33c-16,25.1-1.14,48-1.14,48l8.87,1.8,35.53-32.62s2.23-24.92,4.05-34.94,10.32-16.35,10.32-16.35l1.84-5.89a14.24,14.24,0,0,1,14.56-10l1.14.07Z"
        style={{
          fill: "rgb(255, 114, 94)",
          transformOrigin: "262.305px 125.63px 0px",
        }}
        id="elil43yiaux"
        className="animable"
      />
      <path
        d="M291.37,92.64s-.22-.15-.54-.52a10.41,10.41,0,0,1-1.17-1.71,11.71,11.71,0,0,1,1.09-12.93A9.92,9.92,0,0,1,292.19,76c.37-.31.6-.45.62-.42s-.78.74-1.76,2.13A12.15,12.15,0,0,0,290,90.24C290.73,91.78,291.45,92.59,291.37,92.64Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "290.51px 84.108px 0px",
        }}
        id="el0kqd9xkuweu"
        className="animable"
      />
      <path
        d="M294.34,59.61c-.06,1.58-5,2.68-10.95,2.45s-10.81-1.69-10.75-3.27,5-2.68,11-2.45S294.4,58,294.34,59.61Z"
        style={{
          fill: "rgb(255, 114, 94)",
          transformOrigin: "283.49px 59.2px 0px",
        }}
        id="elzn30wi0swnd"
        className="animable"
      />
      <g id="el2rhgebj7t6g">
        <g
          style={{
            opacity: 0.3,
            transformOrigin: "283.49px 59.2px 0px",
          }}
          className="animable"
        >
          <path
            d="M294.34,59.61c-.06,1.58-5,2.68-10.95,2.45s-10.81-1.69-10.75-3.27,5-2.68,11-2.45S294.4,58,294.34,59.61Z"
            id="elzzu77rrphs"
            style={{
              transformOrigin: "283.49px 59.2px 0px",
            }}
            className="animable"
          />
        </g>
      </g>
      <path
        d="M294.28,59.76s0,.08-.14.19a2.9,2.9,0,0,1-.52.44,7.54,7.54,0,0,1-2.24,1.07,24.57,24.57,0,0,1-8.07.78,27.71,27.71,0,0,1-8-1.34,6.65,6.65,0,0,1-2.16-1.22,2.11,2.11,0,0,1-.45-.51c-.09-.13-.12-.2-.11-.21s.22.24.69.57a7.69,7.69,0,0,0,2.15,1,32.67,32.67,0,0,0,7.91,1.16,27.8,27.8,0,0,0,7.95-.62A10.26,10.26,0,0,0,294.28,59.76Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "283.434px 60.6294px 0px",
        }}
        id="el1t1x4p05glk"
        className="animable"
      />
      <g id="elsilfykv5au">
        <g
          style={{
            opacity: 0.2,
            transformOrigin: "246.52px 147.739px 0px",
          }}
          className="animable"
        >
          <path
            d="M250.17,127.45c-13.32,4.81-19,15.5-21.57,26.69-.69,3-1,6.2,0,9.1s3.69,5.4,6.77,5.38c3.8,0,6.6-3.59,8.06-7.1s2.3-7.45,4.93-10.18c4.23-4.39,11.94-4.46,15.34-9.52,2.39-3.56,1.54-8.77-1.53-11.78a12.26,12.26,0,0,0-12-2.59"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "246.52px 147.739px 0px",
            }}
            id="elkjep2lbxoo"
            className="animable"
          />
        </g>
      </g>
      <path
        d="M275.5,66.62a13.8,13.8,0,0,1-.22,1.77c-.17,1.13-.46,2.76-.86,4.78a155.7,155.7,0,0,1-3.95,15.52,158.66,158.66,0,0,1-5.5,15c-.81,1.88-1.49,3.39-2,4.42a12.91,12.91,0,0,1-.82,1.59,11.29,11.29,0,0,1,.63-1.67c.45-1,1.08-2.58,1.84-4.48,1.52-3.8,3.5-9.1,5.35-15.06s3.2-11.45,4.08-15.44c.45-2,.79-3.62,1-4.74A9.93,9.93,0,0,1,275.5,66.62Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "268.825px 88.16px 0px",
        }}
        id="elmdai2xazo68"
        className="animable"
      />
      <path
        d="M298.71,78a6.44,6.44,0,0,1-2.59.23,6.35,6.35,0,0,1-2.59-.29,13,13,0,0,1,5.18.06Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "296.12px 77.9904px 0px",
        }}
        id="el9a3vlt02c8e"
        className="animable"
      />
      <path
        d="M386.94,100.61a32,32,0,0,0-13.4-13.49Q371.41,86,369.27,85a5.45,5.45,0,0,1-3.06-6.51,17.24,17.24,0,0,1,1.35-3.35l-11.17-4.92a22.74,22.74,0,0,1-2.18,4,6.79,6.79,0,0,1-11,.4,21.7,21.7,0,0,1-1.72-2.6c-3.87-6.85-3.34-9-3.34-9l-19.05,4s1.05,8.68.22,12.3a17.73,17.73,0,0,1-4.42,8.07c-21.43,11.83-30,21.44-30,21.44l-15.81,15.26-2.32,20,3.2,21.81,45.8-6.13s29.34-27.5,29.71-28.47S369.14,126,369.14,126l19.39-6.71C391.16,112.21,389.5,105.64,386.94,100.61Z"
        style={{
          fill: "rgb(255, 114, 94)",
          transformOrigin: "328.315px 114.46px 0px",
        }}
        id="elbhptcx4fku5"
        className="animable"
      />
      <g id="el7mrhzebx46a">
        <g
          style={{
            opacity: 0.3,
            transformOrigin: "328.315px 114.46px 0px",
          }}
          className="animable"
        >
          <path
            d="M386.94,100.61a32,32,0,0,0-13.4-13.49Q371.41,86,369.27,85a5.45,5.45,0,0,1-3.06-6.51,17.24,17.24,0,0,1,1.35-3.35l-11.17-4.92a22.74,22.74,0,0,1-2.18,4,6.79,6.79,0,0,1-11,.4,21.7,21.7,0,0,1-1.72-2.6c-3.87-6.85-3.34-9-3.34-9l-19.05,4s1.05,8.68.22,12.3a17.73,17.73,0,0,1-4.42,8.07c-21.43,11.83-30,21.44-30,21.44l-15.81,15.26-2.32,20,3.2,21.81,45.8-6.13s29.34-27.5,29.71-28.47S369.14,126,369.14,126l19.39-6.71C391.16,112.21,389.5,105.64,386.94,100.61Z"
            id="el6o6c62ynmga"
            style={{
              transformOrigin: "328.315px 114.46px 0px",
            }}
            className="animable"
          />
        </g>
      </g>
      <path
        d="M292.14,153.1c-7.75,2.4-79.92,19.68-73.28,72.84s37.43,78.4,53.07,92.35,37.95,35.4,62.91,28.68S388,290,396.71,264.63s13-56.36-2-68.63l-74.38-53.07S304.1,149.4,292.14,153.1Z"
        style={{
          fill: "rgb(255, 114, 94)",
          transformOrigin: "311.525px 245.585px 0px",
        }}
        id="elpku656ryajq"
        className="animable"
      />
      <g id="elmhokad9sto">
        <g
          style={{
            opacity: 0.2,
            transformOrigin: "376.085px 195.086px 0px",
          }}
          className="animable"
        >
          <path
            d="M355,186.94S362,201.43,378.84,203c15.6,1.49,18.33-4.69,18.33-4.69a32.56,32.56,0,0,0-6.68-5.37Z"
            id="eliwzkcjv4hnh"
            style={{
              transformOrigin: "376.085px 195.086px 0px",
            }}
            className="animable"
          />
        </g>
      </g>
      <path
        d="M306.09,84.56c-.16,4.35-1.39,7.83-2.75,7.78s-2.32-3.62-2.16-8,1.4-7.84,2.76-7.78S306.26,80.21,306.09,84.56Z"
        style={{
          fill: "rgb(255, 114, 94)",
          transformOrigin: "303.636px 84.4499px 0px",
        }}
        id="el57g400z6dkh"
        className="animable"
      />
      <path
        d="M338.12,63.12c.29,1.34-3.71,3.37-8.95,4.53s-9.73,1-10-.32,3.71-3.37,8.95-4.53S337.82,61.78,338.12,63.12Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "328.646px 65.2216px 0px",
        }}
        id="elr498xwfqtmk"
        className="animable"
      />
      <path
        d="M301.3,150.05s19.23-28.12,58.68-32.93c0,0,20.32-4.08,45.32,9.21l-9.2,28.91s-12.29-4.3-25.21-1.28c0,0-21.84,5.19-22.61,27.09"
        style={{
          fill: "rgb(255, 114, 94)",
          transformOrigin: "353.3px 148.79px 0px",
        }}
        id="ellbrffpx4y5f"
        className="animable"
      />
      <path
        d="M403.79,141.85c-2.64,8-6.4,13.86-8.4,13.2s-1.5-7.66,1.14-15.61,6.39-13.86,8.4-13.2S406.42,133.89,403.79,141.85Z"
        style={{
          fill: "rgb(255, 114, 94)",
          transformOrigin: "400.161px 140.645px 0px",
        }}
        id="elaqrf1q3k4vd"
        className="animable"
      />
      <g id="ellbenlwzvmei">
        <g
          style={{
            opacity: 0.2,
            transformOrigin: "303.15px 241.1px 0px",
          }}
          className="animable"
        >
          <path
            d="M279.35,213.11h0S279.35,213.11,279.35,213.11Z"
            id="eltlv6hv9fe1n"
            style={{
              transformOrigin: "279.35px 213.11px 0px",
            }}
            className="animable"
          />
          <path
            d="M301.41,184.61a11.75,11.75,0,0,0,2.41-.14,8,8,0,0,0,2.32-.82,17,17,0,0,0,3.71-2.82c.55-.51,1.08-1.05,1.62-1.51a2.88,2.88,0,0,1,1.65-.9c1.56-.07,3-.38,4.47-.37a4.57,4.57,0,0,1,1.05.11,1.43,1.43,0,0,1,.84.44,14.77,14.77,0,0,0,1.47,1.71,12.55,12.55,0,0,0,1.74,1.44,4,4,0,0,0,2.07.81,3.83,3.83,0,0,1-2-.93,12.28,12.28,0,0,1-1.61-1.53,12,12,0,0,1-1.34-1.78,2,2,0,0,0-1.05-.66,5.33,5.33,0,0,0-1.17-.21c-1.53-.11-3.05.12-4.48.08a3,3,0,0,0-.69.07,3.71,3.71,0,0,0-.61.25,7.66,7.66,0,0,0-1,.66c-.62.47-1.18,1-1.76,1.43a16,16,0,0,1-3.56,2.38,6.49,6.49,0,0,1-1.93.54,11,11,0,0,1-2.06,0,28.51,28.51,0,0,1-8.29-2.26v0a21.84,21.84,0,0,1-2.39-8,20.33,20.33,0,0,1,0-4.2,19.91,19.91,0,0,1,.34-2.05,13.21,13.21,0,0,1,.57-1.92l-.05,0a34.4,34.4,0,0,1,2.72-3.43c.63-.71,1.3-1.4,2-2,.35-.32.7-.63,1-.92l.52-.41.24-.16.08-.05s0,0,0,0l-.72-2.26-.36.16-.23.14c-.15.09-.27.18-.38.26s-.43.34-.64.51q-.58.51-1.14,1.05c-.74.71-1.43,1.45-2.1,2.22a38.46,38.46,0,0,0-3.09,4.09l-.07,0c0,.08-.05.16-.08.25l-.37.59c-2.16,3.46-3.38,7.31-5.86,10a15,15,0,0,1-2,1.86,23.38,23.38,0,0,1-2.4,1.51c-1.72,1-3.43,2-5.11,3.06a47.57,47.57,0,0,0-4.88,3.53,17.56,17.56,0,0,0-3.56,3.87,60.79,60.79,0,0,0-9.35,0c-.42.07-.83.11-1.27.22a3.89,3.89,0,0,0-.68.19l-.35.13-.31.16a21.42,21.42,0,0,0-2.08,1.37c-1.3.93-2.57,1.88-3.84,2.82a70.28,70.28,0,0,1-7.79,5.24c-.34.19-.68.32-1,.48s-.63.21-1.08.32a8.15,8.15,0,0,0-2.3,1,12.46,12.46,0,0,0-3.53,3.37l0,.06v.06L229,218.19l3.24-14.3a11.89,11.89,0,0,1,3.4-3,7.44,7.44,0,0,1,2.07-.79,12,12,0,0,0,1.21-.31,11.55,11.55,0,0,0,1.15-.47,71.73,71.73,0,0,0,8.19-5c1.31-.89,2.62-1.78,3.93-2.63a18.54,18.54,0,0,1,1.94-1.15l.22-.11.21-.06a2.51,2.51,0,0,1,.47-.11c.32-.07.71-.09,1.07-.13a56.15,56.15,0,0,1,8.56.38l0,2,0,1.58a4.92,4.92,0,0,1-.17,1.36,4.44,4.44,0,0,1-1.47,2.21,6.24,6.24,0,0,1-1.24.73l-1.4.75a57.68,57.68,0,0,0-5.46,3.33,21.37,21.37,0,0,0-4.82,4.36c-.16.23-.31.48-.46.71s-.26.53-.39.79c-.2.52-.38,1-.53,1.53a31.61,31.61,0,0,0-.81,3.11c-.46,2.08-.76,4.16-1.21,6.19a21,21,0,0,1-.88,3,7.87,7.87,0,0,1-1.5,2.54,22.21,22.21,0,0,1-2.41,1.95,9.24,9.24,0,0,0-2.18,2.44,18.67,18.67,0,0,0-2.13,6.06c-.43,2.07-.76,4.16-1,6.25q-.78,6.28-1,12.62c0,1.05-.06,2.11-.05,3.16a18.86,18.86,0,0,0,.19,3.18c.39,2.16,1.83,3.84,2.84,5.65a9.08,9.08,0,0,1,.62,1.43,10.94,10.94,0,0,1,.33,1.53c.15,1,.25,2.09.37,3.13a29.36,29.36,0,0,0,.49,3.12,7.91,7.91,0,0,0,1.21,2.9,7.94,7.94,0,0,1-1.16-2.91,27.23,27.23,0,0,1-.44-3.12c-.1-1.05-.18-2.1-.32-3.14a10.25,10.25,0,0,0-.31-1.56,9,9,0,0,0-.61-1.48c-1-1.85-2.39-3.53-2.72-5.61a20.14,20.14,0,0,1-.14-3.12c0-1.05,0-2.1.1-3.15.2-4.2.6-8.39,1.18-12.54.31-2.08.67-4.15,1.13-6.19a18.14,18.14,0,0,1,2.12-5.78,8.49,8.49,0,0,1,2-2.2l1-.72a30,30,0,0,0-1.41,3A16.63,16.63,0,0,0,240.7,235a7.94,7.94,0,0,0,.35,2.77c.29.85.61,1.7.95,2.53.69,1.66,1.42,3.29,2,4.95a64.07,64.07,0,0,1,2.83,10.3,40,40,0,0,0,1.28,5.24,11.4,11.4,0,0,0,1.19,2.46c.52.77,1.17,1.39,1.68,2.1a16.14,16.14,0,0,1,2.16,4.82,20.74,20.74,0,0,0,1.83,5.06,6,6,0,0,0,1.86,2,6.59,6.59,0,0,0,2.57.87c1.78.24,3.61.22,5.21,1s2.67,2.3,4,3.53c.62.64,1.26,1.27,1.94,1.86a8.65,8.65,0,0,0,2.23,1.5,6.3,6.3,0,0,0,2.64.47,12.62,12.62,0,0,1,2.67.17,23.11,23.11,0,0,1,5.12,1.56,23,23,0,0,0-5.11-1.61c-1.76-.41-3.64.11-5.28-.68a15.27,15.27,0,0,1-4.11-3.37c-.62-.65-1.22-1.3-1.83-2a7.28,7.28,0,0,0-2.14-1.64c-1.64-.85-3.52-.85-5.26-1.1a6.08,6.08,0,0,1-2.46-.86,5.73,5.73,0,0,1-1.75-1.91,20.41,20.41,0,0,1-1.76-5,16.31,16.31,0,0,0-2.17-4.95c-.53-.75-1.17-1.38-1.65-2.11a10.93,10.93,0,0,1-1.11-2.37,39.16,39.16,0,0,1-1.22-5.19A64.89,64.89,0,0,0,244.61,245c-.61-1.69-1.34-3.33-2-5-.34-.82-.64-1.66-.92-2.49a7.17,7.17,0,0,1-.29-2.53,15.87,15.87,0,0,1,1.26-5.07,28.87,28.87,0,0,1,2.46-4.67l-.05,0a8.91,8.91,0,0,0,1.59-2.65,21.14,21.14,0,0,0,1-3.08c.5-2.07.84-4.15,1.31-6.18.11-.46.23-.93.35-1.38,0,.52,0,1,0,1.57a10.49,10.49,0,0,0,.49,3.08,7.46,7.46,0,0,0,.68,1.42,8.09,8.09,0,0,1,.65,1.32,11,11,0,0,1,.63,2.88,10.81,10.81,0,0,0,.61,3,7.16,7.16,0,0,0,1.81,2.52A8.08,8.08,0,0,1,256,230a5.36,5.36,0,0,1,.38,2.87,27.42,27.42,0,0,1-.43,3c-.16.87-.33,1.74-.5,2.61l-.18.12a1.79,1.79,0,0,0,.13.14c-.19,1-.36,2.07-.46,3.12a14.14,14.14,0,0,0,0,3,21.84,21.84,0,0,0,.64,3,17.25,17.25,0,0,0,2.61,5.45,17.05,17.05,0,0,1-2.51-5.48,19.88,19.88,0,0,1-.59-3,13.77,13.77,0,0,1,0-3c.11-1,.28-1.95.47-2.92a5.56,5.56,0,0,0,1.16.77,11.47,11.47,0,0,0,1.63.68,20.64,20.64,0,0,0,3.37.8,22,22,0,0,0,3.43.28,11.44,11.44,0,0,0,3.4-.46,11.38,11.38,0,0,1-3.39.26,22.71,22.71,0,0,1-6.61-1.43,12.85,12.85,0,0,1-1.49-.73,4.52,4.52,0,0,1-1.18-1l-.18.12c.16-.79.34-1.57.49-2.36a30,30,0,0,0,.49-3,5.79,5.79,0,0,0-.38-3.07,8.13,8.13,0,0,0-1.94-2.4,6.58,6.58,0,0,1-1.66-2.38,10.63,10.63,0,0,1-.53-2.91,11.51,11.51,0,0,0-.62-3,9.16,9.16,0,0,0-.66-1.42,6.71,6.71,0,0,1-.61-1.31,9.62,9.62,0,0,1-.41-2.89,21.91,21.91,0,0,1,.67-5.22v0l.41-.6a20.09,20.09,0,0,1,4.58-4,56.54,56.54,0,0,1,5.38-3.16l1.39-.71a7.54,7.54,0,0,0,1.49-.87,4.25,4.25,0,0,0,.39-.35,22.82,22.82,0,0,0,2.48,2.34,17.45,17.45,0,0,0,3.73,2.33c.34.17.7.28,1,.43s.52.21.78.35a6.27,6.27,0,0,1,1.4,1.11,13.42,13.42,0,0,1,2.21,3.16,22.79,22.79,0,0,1,1.52,3.68c.1.31.19.64.26.94a3.43,3.43,0,0,1,.09.44,2.8,2.8,0,0,0,.18.51l.19.29a7.15,7.15,0,0,0,.79.9l-2.08,11.26A5.87,5.87,0,0,0,275,228a5.24,5.24,0,0,0-.89,2.41l-.92,5,1.1-5a4.93,4.93,0,0,1,.93-2.29,5.56,5.56,0,0,1,1.87-1.58l.08,0,0-.08,2.39-10.8.12.1c2.13,1.86,4.36,3.49,6.59,5.13a7.55,7.55,0,0,1,1.45,1.29,11.08,11.08,0,0,1,1.14,1.61,17.88,17.88,0,0,1,1.64,3.68,16.21,16.21,0,0,1,.8,4,17.37,17.37,0,0,1-.3,4c-.43,2.7-1.24,5.38-1.35,8.19a5.47,5.47,0,0,0,.33,2.08,7.24,7.24,0,0,0,.53.91c.17.3.34.6.5.9a22.78,22.78,0,0,1,1.56,3.83,22.79,22.79,0,0,0-1.43-3.9c-.15-.31-.31-.62-.47-.92a6.56,6.56,0,0,1-.48-.9,5.14,5.14,0,0,1-.24-2c.2-2.73,1.1-5.37,1.63-8.1a17.65,17.65,0,0,0,.46-4.19,17.4,17.4,0,0,0-.69-4.17,19.66,19.66,0,0,0-1.58-3.94,13.34,13.34,0,0,0-1.19-1.8,7.4,7.4,0,0,0-.76-.83c-.29-.27-.56-.48-.83-.69-2.16-1.72-4.33-3.43-6.31-5.28a9.37,9.37,0,0,1-1.27-1.39l-.09-.14v0c0-.16-.06-.42-.1-.58-.07-.38-.16-.72-.25-1.07a25.25,25.25,0,0,0-1.5-4,15.47,15.47,0,0,0-2.4-3.69,8.23,8.23,0,0,0-1.79-1.51c-.34-.2-.75-.38-1.09-.54s-.58-.23-.86-.38a17.76,17.76,0,0,1-5.7-4.79c.08-.2.17-.39.23-.59a6.36,6.36,0,0,0,.26-1.76l0-1.58.09-2.94a15,15,0,0,1,3.62-4,48.42,48.42,0,0,1,4.75-3.31c1.66-1,3.36-2,5.08-2.93a27.06,27.06,0,0,0,2.62-1.6,16.66,16.66,0,0,0,2.36-2.08,22.6,22.6,0,0,0,3.43-5.12c.14-.27.28-.55.43-.82a20.33,20.33,0,0,0,.19,3,23.81,23.81,0,0,0,2.93,8.68l.66,1.13,0,.1.13,0c1.26,2.15,2.58,4.24,4,6.29a28.94,28.94,0,0,0,2.87,3.51,17.17,17.17,0,0,0,3.6,2.82,31.2,31.2,0,0,1,3.72,2.28,6.78,6.78,0,0,1,2.52,3.19,4.06,4.06,0,0,1,.1,2c-.15.66-.37,1.42-.52,2.13-.34,1.44-.65,2.89-.94,4.33s-.57,2.91-.81,4.36a36,36,0,0,0-.54,4.42,5.12,5.12,0,0,0,.53,2.19,11.22,11.22,0,0,0,1.11,1.93,22.51,22.51,0,0,0,2.88,3.36,23.38,23.38,0,0,1-2.76-3.44,11.28,11.28,0,0,1-1-1.94,4.93,4.93,0,0,1-.43-2.09,36.33,36.33,0,0,1,.67-4.35c.3-1.44.62-2.88,1-4.31s.69-2.86,1.08-4.28c.18-.73.4-1.37.59-2.15a4.84,4.84,0,0,0,0-2.39,7.77,7.77,0,0,0-2.72-3.77,31.61,31.61,0,0,0-3.74-2.46,16.19,16.19,0,0,1-3.26-2.73,27.43,27.43,0,0,1-2.61-3.43c-1-1.53-1.94-3.11-2.85-4.72.65.18,1.3.34,2,.48A26.3,26.3,0,0,0,301.41,184.61Z"
            id="elmrirjotv3a"
            style={{
              transformOrigin: "276.88px 221.695px 0px",
            }}
            className="animable"
          />
          <path
            d="M371.55,299.5c-.23-.61-.47-1.22-.74-1.82-.13-.29-.27-.59-.43-.88a2.18,2.18,0,0,0-.62-.77,5.87,5.87,0,0,0-1.86-.64c-.64-.14-1.29-.24-1.93-.32-1.29-.18-2.62-.26-3.87-.5-.29-.06-.29-.41-.21-.71a4.36,4.36,0,0,1,.35-.88,19,19,0,0,1,1-1.68c.7-1.1,1.5-2.11,2.17-3.27a3.89,3.89,0,0,0,0-2,9,9,0,0,0-.61-1.9,15.91,15.91,0,0,0-2.07-3.36c-.41-.51-.85-1-1.29-1.5a12.55,12.55,0,0,1-1.16-1.53,23.23,23.23,0,0,1-1.81-3.42,45.27,45.27,0,0,1-2.38-7.4,48.59,48.59,0,0,1-1.15-7.68c-.06-.92-.08-1.84-.07-2.76.16-.38.33-.74.48-1.12l-.45-.18v0c1.41-5.92,3.21-11.76,5.17-17.54l.4-1.2.2-.61c.06-.23.13-.47.17-.7a16.31,16.31,0,0,0,.24-2.65,46.07,46.07,0,0,0-.26-5.14,67.49,67.49,0,0,0-1.08-6.91c.37.24.75.5,1.1.77a17.65,17.65,0,0,1,2.69,2.49,11.82,11.82,0,0,1,1.95,3,27.22,27.22,0,0,1,1.13,3.57c.65,2.49,1.18,5,1.72,7.57.14.64.28,1.28.43,1.93.09.33.17.65.3,1l.12.3a1.67,1.67,0,0,0,.16.24l.12.15.26.3c.79,1,1.56,2,2.31,3.09s1.48,2.12,2.18,3.2a25.64,25.64,0,0,1,1.87,3.32,6.13,6.13,0,0,1,.33,1.79c.06.64.09,1.28.11,1.92,0,1.29,0,2.59,0,3.88,0,.65-.08,1.29-.14,1.93a11.65,11.65,0,0,1-.31,1.89c-.35,1.22-.89,2.43-1.22,3.7a7.74,7.74,0,0,0-.09,3.91,8.24,8.24,0,0,0,1.95,3.36,8.15,8.15,0,0,1-1.81-3.39,7.55,7.55,0,0,1,.24-3.8c.36-1.24.95-2.39,1.35-3.66a9.52,9.52,0,0,0,.4-1.95c.09-.65.16-1.3.22-1.95.11-1.3.17-2.61.19-3.92,0-.66,0-1.32,0-2a6.84,6.84,0,0,0-.31-2,25.2,25.2,0,0,0-1.82-3.55c-.66-1.13-1.36-2.24-2.08-3.33s-1.44-2.17-2.24-3.25c-.11-.13-.2-.26-.37-.44,0,0-.05-.05,0-.06h0l0,0-.06-.17a8,8,0,0,1-.21-.87c-.13-.62-.24-1.25-.35-1.89-.44-2.56-.89-5.14-1.45-7.71a28.26,28.26,0,0,0-1.08-3.9,14,14,0,0,0-2.13-3.6,19.59,19.59,0,0,0-2.92-2.91,21,21,0,0,0-3.19-2.16c-.71-3.19-1.2-6.54-1.72-9.84s-1-6.64-1.45-10q-1.39-10-2.67-20l-2.35.31c.93,6.67,1.88,13.32,2.89,20,.51,3.32,1,6.65,1.57,10s1.08,6.63,1.86,10a65.9,65.9,0,0,1,1.92,9.77,43.09,43.09,0,0,1,.32,4.93c0,.39,0,.79,0,1.18a4.2,4.2,0,0,0-1.57.45,8.38,8.38,0,0,0-1.59,1.09,22.31,22.31,0,0,0-2.45,2.52c-1.47,1.74-2.77,3.55-4.15,5.25-.34.42-.69.83-1.05,1.21a4.74,4.74,0,0,1-1,.9l-.13.06-.36,0-.76,0c-.53,0-1.07,0-1.61-.09s-1.08-.11-1.62-.19a5.39,5.39,0,0,1-1.43-.38,5.26,5.26,0,0,1-2.29-1.84c-.16-.22-.23-.38-.43-.69a3.56,3.56,0,0,0-2.45-1.53c-.71-.07-1.14,0-1.7,0a9.14,9.14,0,0,1-1.57-.23,10.21,10.21,0,0,1-5.43-3.23,3.32,3.32,0,0,1-.67-1.37,4.54,4.54,0,0,0-.71-1.61,1.62,1.62,0,0,0-.76-.57,1.43,1.43,0,0,0-.94,0,3.62,3.62,0,0,1-1.58.16,12.43,12.43,0,0,1-3.2-.76,12.09,12.09,0,0,1-1.52-.67,3.06,3.06,0,0,1-1.27-1,3.14,3.14,0,0,0,1.24,1.1,12.15,12.15,0,0,0,1.49.74,12.44,12.44,0,0,0,3.23.92,3.91,3.91,0,0,0,1.73-.1,1,1,0,0,1,1.22.44,4.09,4.09,0,0,1,.55,1.45,4,4,0,0,0,.71,1.63,11.1,11.1,0,0,0,7.39,4.07c.55.08,1.24,0,1.63.11a2.36,2.36,0,0,1,1.2.6,2.28,2.28,0,0,1,.42.51c.09.16.26.5.42.74a6.43,6.43,0,0,0,1.59,1.7c-1.14.84-2.32,1.65-3.54,2.38a19,19,0,0,1-2.05,1.06,4,4,0,0,1-2.09.43l-2.33-.48c-.4-.08-.75-.18-1.19-.23a3,3,0,0,0-1.26.18,3,3,0,0,0-1.07.67c-.29.25-.59.5-.9.74a12.23,12.23,0,0,1-1.92,1.3,3.25,3.25,0,0,1-2.12.5,5.45,5.45,0,0,0-2.41,0,10.4,10.4,0,0,0-2.27.74,5.88,5.88,0,0,0-2,1.34c-1,1.25-1.8,2.59-2.67,3.91s-1.68,2.66-2.51,4c.86-1.33,1.72-2.64,2.6-4S314,255,315,253.76a5.57,5.57,0,0,1,1.93-1.24,10.17,10.17,0,0,1,2.22-.68,5.26,5.26,0,0,1,2.27,0,3.45,3.45,0,0,0,2.39-.48,14.13,14.13,0,0,0,2-1.29c.31-.24.62-.49.92-.75a2.72,2.72,0,0,1,.93-.56,2.38,2.38,0,0,1,1.06-.12c.34,0,.75.16,1.12.24l2.29.52a3,3,0,0,0,.68.06,4.16,4.16,0,0,0,.63-.09,8.86,8.86,0,0,0,1.17-.37,22.75,22.75,0,0,0,2.16-1.06,43.06,43.06,0,0,0,3.89-2.52,4.91,4.91,0,0,0,.44.25,7.07,7.07,0,0,0,1.76.56q.84.15,1.68.27c.57.08,1.14.14,1.72.17.3,0,.6,0,.9,0l.48,0a2.23,2.23,0,0,0,.66-.2,6.11,6.11,0,0,0,1.54-1.18c.43-.41.81-.83,1.19-1.26,1.5-1.69,2.87-3.43,4.35-5a20.1,20.1,0,0,1,2.28-2.17,5.61,5.61,0,0,1,1.19-.74s.05,0,.07,0l-.32,1a191.35,191.35,0,0,0-5.3,19.53c-.2,1-.39,2-.56,3-.5,1.11-1,2.22-1.54,3.31a61.84,61.84,0,0,1-4.23,7.49,20,20,0,0,1-2.71,3.28,9,9,0,0,1-3.65,2,34.43,34.43,0,0,1-8.47,1.27,75.33,75.33,0,0,1-8.63-.16,5.14,5.14,0,0,0-2.17.44c-.68.26-1.34.56-2,.84a14.77,14.77,0,0,1-2,.73,4,4,0,0,1-1,.13,4.9,4.9,0,0,1-1-.23c-1.39-.37-2.78-.79-4.2-1.06a5,5,0,0,0-1.09-.12,1,1,0,0,0-.29,0,.66.66,0,0,0-.24.18l-.37.4c-.49.53-1,1-1.53,1.52a22.41,22.41,0,0,1-3.41,2.65,9.09,9.09,0,0,1-4,1.46,9.12,9.12,0,0,0,4.05-1.42,21.87,21.87,0,0,0,3.45-2.61c.54-.48,1.06-1,1.56-1.51l.37-.39a.37.37,0,0,1,.18-.14,1.07,1.07,0,0,1,.25,0,5.47,5.47,0,0,1,1.06.12c1.4.29,2.78.73,4.17,1.12a5.32,5.32,0,0,0,1.08.25,4.09,4.09,0,0,0,1.1-.13,14.3,14.3,0,0,0,2.06-.71c.67-.28,1.33-.57,2-.81a5,5,0,0,1,2-.4,76.1,76.1,0,0,0,8.67.27,34.52,34.52,0,0,0,8.62-1.19,9.57,9.57,0,0,0,3.89-2.09,20.36,20.36,0,0,0,2.82-3.35,64.28,64.28,0,0,0,4.36-7.53c.17-.35.33-.71.5-1.06-.2,1.49-.37,3-.44,4.5l-.08,2.52c-.05.82-.12,1.64-.25,2.44a16.09,16.09,0,0,1-1.45,4.66,14.72,14.72,0,0,1-2.86,3.94c-.58.58-1.2,1.13-1.83,1.69a8.52,8.52,0,0,0-1.79,1.93,17.45,17.45,0,0,1-1.6,1.83l-1.75,1.81c-1.17,1.21-2.34,2.43-3.48,3.66a118.64,118.64,0,0,0-12.63,15.74c-3.67,5.63-6.76,11.78-7.93,18.43,1.27-6.63,4.46-12.71,8.2-18.25a107.28,107.28,0,0,1,9.42-11.84,59.12,59.12,0,0,0-.94,7.5,27.61,27.61,0,0,0,.63,8.59,8.53,8.53,0,0,0,2,3.81,7.56,7.56,0,0,1,2.28,3.5A33.48,33.48,0,0,1,339.5,327a33.64,33.64,0,0,0-1.46-8.44,11.28,11.28,0,0,0-.88-2,5.92,5.92,0,0,0-.62-.89c-.23-.29-.53-.52-.76-.77a8.24,8.24,0,0,1-1.87-3.7,26.9,26.9,0,0,1-.42-8.45,58,58,0,0,1,1.32-8.41l-.14,0c.85-.92,1.71-1.84,2.57-2.74,1.17-1.21,2.35-2.4,3.53-3.59l1.78-1.79a18.65,18.65,0,0,0,1.75-1.94,7.81,7.81,0,0,1,1.65-1.71c.64-.55,1.29-1.1,1.9-1.7a15.75,15.75,0,0,0,3.1-4.14,17.17,17.17,0,0,0,1.62-4.91c.15-.85.23-1.71.3-2.57l.12-2.51a61,61,0,0,1,1.24-8.46c0,.33,0,.65,0,1a47.51,47.51,0,0,0,1.27,7.77,44.47,44.47,0,0,0,2.5,7.46,24.28,24.28,0,0,0,1.89,3.47,15.35,15.35,0,0,0,1.22,1.57c.45.48.88,1,1.29,1.46a15.38,15.38,0,0,1,2.07,3.26,9,9,0,0,1,.61,1.81,3.69,3.69,0,0,1,0,1.84c-.61,1.11-1.42,2.16-2.11,3.27a18,18,0,0,0-1,1.71,4.23,4.23,0,0,0-.35.94,1.29,1.29,0,0,0,0,.52.49.49,0,0,0,.38.41c1.32.25,2.61.3,3.91.47.65.07,1.29.16,1.93.29a5.79,5.79,0,0,1,1.83.6,4.35,4.35,0,0,1,1,1.61c.27.59.51,1.19.75,1.8.47,1.22.9,2.45,1.31,3.69C372.42,302,372,300.73,371.55,299.5Z"
            id="el52gsidw3ed2"
            style={{
              transformOrigin: "338.755px 252.195px 0px",
            }}
            className="animable"
          />
        </g>
      </g>
      <path
        d="M378,153s22.09-1.1,33.21,12.73l-2.6,12.85-11.39-2.31.26,1.56c-.07.34,11.85,2.42,11.85,2.42L407.17,193l-8.57-1.74s-3.14,4.12-10.49,5.66-24.78,3.41-33.16-10-1.09-22,0-23.23A34.77,34.77,0,0,1,378,153Z"
        style={{
          fill: "rgb(255, 114, 94)",
          transformOrigin: "381.091px 175.486px 0px",
        }}
        id="elnl1n0qria0t"
        className="animable"
      />
      <g id="eljh3xdlagin9">
        <g
          style={{
            opacity: 0.3,
            transformOrigin: "381.091px 175.486px 0px",
          }}
          className="animable"
        >
          <path
            d="M378,153s22.09-1.1,33.21,12.73l-2.6,12.85-11.39-2.31.26,1.56c-.07.34,11.85,2.42,11.85,2.42L407.17,193l-8.57-1.74s-3.14,4.12-10.49,5.66-24.78,3.41-33.16-10-1.09-22,0-23.23A34.77,34.77,0,0,1,378,153Z"
            id="el5po34n223ab"
            style={{
              transformOrigin: "381.091px 175.486px 0px",
            }}
            className="animable"
          />
        </g>
      </g>
      <path
        d="M411.5,172.5c-.71,3.52-2,6.22-2.86,6.05s-1-3.17-.27-6.69,2-6.22,2.86-6S412.22,169,411.5,172.5Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "409.933px 172.203px 0px",
        }}
        id="elwbaqfbzsp0l"
        className="animable"
      />
      <path
        d="M409.82,186.92c-.72,3.52-2,6.22-2.87,6.05s-1-3.17-.27-6.69,2-6.21,2.86-6S410.53,183.41,409.82,186.92Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "408.242px 186.623px 0px",
        }}
        id="el7vqscotsudv"
        className="animable"
      />
      <path
        d="M397.33,175.43a2.73,2.73,0,0,1-.73-.42,9.32,9.32,0,0,1-1.66-1.59,10.39,10.39,0,0,1,.5-14,9.38,9.38,0,0,1,1.77-1.46,2.37,2.37,0,0,1,.76-.37,23.41,23.41,0,0,0-2.26,2.08,10.51,10.51,0,0,0-.49,13.5A25.7,25.7,0,0,0,397.33,175.43Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "395.219px 166.51px 0px",
        }}
        id="elbo7siltik8a"
        className="animable"
      />
      <path
        d="M395.18,189.29a3.44,3.44,0,0,1-.9-1.45,7.81,7.81,0,0,1,1.19-7.86c.68-.82,1.25-1.17,1.28-1.12a15.21,15.21,0,0,1-1,1.34,8.79,8.79,0,0,0-1.45,3.63,8.91,8.91,0,0,0,.31,3.89C394.93,188.69,395.25,189.25,395.18,189.29Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "395.231px 184.073px 0px",
        }}
        id="el3pu348rw51m"
        className="animable"
      />
      <path
        d="M407.12,181.33a39.64,39.64,0,0,1-8.88-1.81,20,20,0,0,1,4.49.65A19.43,19.43,0,0,1,407.12,181.33Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "402.68px 180.425px 0px",
        }}
        id="el57mntmcfmw"
        className="animable"
      />
      <path
        d="M409.25,165.44c-.11.11-2.11-1.77-4.89-3.64s-5.27-3-5.2-3.18a23.69,23.69,0,0,1,10.09,6.82Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "404.204px 162.032px 0px",
        }}
        id="eld0rxqm0w8mn"
        className="animable"
      />
      <path
        d="M359.61,165.67a6.6,6.6,0,0,1,.87-1.14,21.35,21.35,0,0,1,2.81-2.7,29.2,29.2,0,0,1,11.55-5.53,40.68,40.68,0,0,1,12.81-.8c1.63.15,3,.35,3.86.51a6.2,6.2,0,0,1,1.39.32,8.21,8.21,0,0,1-1.42-.12c-.91-.1-2.23-.24-3.86-.34a43.55,43.55,0,0,0-12.66.94,30.49,30.49,0,0,0-11.44,5.31A49.56,49.56,0,0,0,359.61,165.67Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "376.255px 160.491px 0px",
        }}
        id="elipss02cnezq"
        className="animable"
      />
      <g id="elm6flosz8h1m">
        <g
          style={{
            opacity: 0.3,
            transformOrigin: "400.161px 140.645px 0px",
          }}
          className="animable"
        >
          <path
            d="M403.79,141.85c-2.64,8-6.4,13.86-8.4,13.2s-1.5-7.66,1.14-15.61,6.39-13.86,8.4-13.2S406.42,133.89,403.79,141.85Z"
            id="elfbeac8n4ukf"
            style={{
              transformOrigin: "400.161px 140.645px 0px",
            }}
            className="animable"
          />
        </g>
      </g>
      <g id="elsrd4gf8bi1">
        <g
          style={{
            opacity: 0.2,
            transformOrigin: "356.528px 134.364px 0px",
          }}
          className="animable"
        >
          <path
            d="M373.31,127.66c-11.16-4.53-23.9-1.55-32.62,5.45-1.85,1.49-3.74,4.68-3.21,7,.61,2.63,4,3.6,6.65,2.89s4.76-2.54,7.23-3.64c6.24-2.78,13.84-.76,20.06-3.61a7.71,7.71,0,0,0,4-3.64,3.34,3.34,0,0,0-2.11-4.45"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "356.528px 134.364px 0px",
            }}
            id="elmhoqb75sae"
            className="animable"
          />
        </g>
      </g>
      <path
        d="M405.3,126.33l-.51-.3-1.52-.86a58.35,58.35,0,0,0-6-2.85,69.54,69.54,0,0,0-10.09-3.3,72,72,0,0,0-13.89-2.1c-.65,0-1.31-.11-2-.11h-2c-1.36,0-2.76-.06-4.18.09l-4.36.31-4.48.66a86.14,86.14,0,0,0-18.82,5.5,97.43,97.43,0,0,0-27.75,18.17,79.73,79.73,0,0,0-8.13,8.67l-.06.08-.09,0c-1.54.39-3.2.83-4.85,1.29-8,2.27-15.76,4.91-23.1,7.77a160.41,160.41,0,0,0-20.56,9.55,81.6,81.6,0,0,0-16.63,11.91,59,59,0,0,0-10.9,14,61.42,61.42,0,0,0-3.3,7.05,58.08,58.08,0,0,0-2.1,6.61,50.31,50.31,0,0,0-1.49,11,49.48,49.48,0,0,0,.37,7c.13.78.22,1.38.29,1.81s.07.62.07.62,0-.21-.13-.61-.19-1-.33-1.81a45.41,45.41,0,0,1-.47-7,49.55,49.55,0,0,1,1.41-11.07,58.49,58.49,0,0,1,2.07-6.67A60.34,60.34,0,0,1,225,194.7a59.34,59.34,0,0,1,10.93-14.19,81.52,81.52,0,0,1,16.68-12,160.07,160.07,0,0,1,20.62-9.61c7.35-2.86,15.08-5.52,23.14-7.79,1.66-.47,3.32-.9,4.87-1.3l-.15.1a79.27,79.27,0,0,1,8.19-8.74,94.75,94.75,0,0,1,9-7.39,93.18,93.18,0,0,1,19-10.83,86.09,86.09,0,0,1,18.94-5.49l4.51-.64,4.38-.3c1.42-.15,2.83-.06,4.2-.08h2c.67,0,1.33.09,2,.12a72,72,0,0,1,13.94,2.19,68,68,0,0,1,10.09,3.38,54.4,54.4,0,0,1,6,3c.67.39,1.17.69,1.5.91A4.48,4.48,0,0,1,405.3,126.33Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "311.794px 172.666px 0px",
        }}
        id="elwfgcn02bap"
        className="animable"
      />
      <path
        d="M398.6,191.27a4.16,4.16,0,0,1-.58.61c-.2.19-.43.45-.74.71l-1.09.87a25,25,0,0,1-8.06,3.76A38.78,38.78,0,0,1,375,198.34a27,27,0,0,1-15-5.71,24.65,24.65,0,0,1-8.67-13.45,18.3,18.3,0,0,1-.28-7.07,17.39,17.39,0,0,1,2-5.83,20.44,20.44,0,0,1,6-6.51,17.75,17.75,0,0,1,2.05-1.29,4.49,4.49,0,0,1,.75-.39,5.89,5.89,0,0,1-.69.48,20.7,20.7,0,0,0-2,1.36,21.14,21.14,0,0,0-5.82,6.53,17.16,17.16,0,0,0-1.92,5.71,18.25,18.25,0,0,0,.31,6.9,24.44,24.44,0,0,0,8.53,13.15A26.76,26.76,0,0,0,375,197.86a38.94,38.94,0,0,0,13-1,25.87,25.87,0,0,0,8-3.56l1.11-.83c.32-.24.56-.49.77-.66A5.94,5.94,0,0,1,398.6,191.27Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "374.715px 178.286px 0px",
        }}
        id="el4afk2rhcd4d"
        className="animable"
      />
      <path
        d="M403.79,141.85a2.58,2.58,0,0,1,.15-.65c.13-.47.29-1.08.5-1.83a48.5,48.5,0,0,0,1.35-6.81,15.36,15.36,0,0,0-.05-4.73c-.17-.79-.68-1.67-1.49-1.34a5.27,5.27,0,0,0-2,1.75,27.23,27.23,0,0,0-3.05,5.21,56.36,56.36,0,0,0-4.1,12.37,27.73,27.73,0,0,0-.67,6,5.32,5.32,0,0,0,.58,2.61c.46.75,1.4.34,2-.19a15.49,15.49,0,0,0,2.86-3.76,49.17,49.17,0,0,0,3-6.27c.29-.73.51-1.31.69-1.77a2.71,2.71,0,0,1,.27-.6,4,4,0,0,1-.17.64c-.12.41-.32,1-.6,1.8a43.18,43.18,0,0,1-2.85,6.38,15.27,15.27,0,0,1-2.91,3.91,3,3,0,0,1-1.23.69,1.31,1.31,0,0,1-1.41-.56,5.67,5.67,0,0,1-.69-2.87,27.78,27.78,0,0,1,.65-6.12,54.1,54.1,0,0,1,1.7-6.36,55.08,55.08,0,0,1,2.43-6.13,28.63,28.63,0,0,1,3.14-5.29,5.69,5.69,0,0,1,2.26-1.89,1.31,1.31,0,0,1,1.46.39,3,3,0,0,1,.59,1.29,15.25,15.25,0,0,1,0,4.87,42.9,42.9,0,0,1-1.52,6.83c-.23.79-.44,1.39-.59,1.8A4.86,4.86,0,0,1,403.79,141.85Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "400.182px 140.628px 0px",
        }}
        id="el0ea5aq6v6b7"
        className="animable"
      />
      <path
        d="M390.83,122a.87.87,0,0,1-.24,0l-.68-.12c-.6-.1-1.48-.3-2.62-.48-2.28-.41-5.59-.89-9.71-1.23a100.79,100.79,0,0,0-14.49-.13A81.14,81.14,0,0,0,345.63,123a64.34,64.34,0,0,0-16.13,7.25A82.8,82.8,0,0,0,318,139c-3.06,2.77-5.4,5.17-7,6.84l-1.83,1.94-.48.5a1,1,0,0,1-.18.16s0-.07.14-.2l.44-.53c.4-.46,1-1.15,1.76-2,1.55-1.73,3.85-4.17,6.89-7a80.48,80.48,0,0,1,11.52-8.9,63.17,63.17,0,0,1,16.23-7.35,79.23,79.23,0,0,1,17.58-2.92,96.18,96.18,0,0,1,14.55.23,91.6,91.6,0,0,1,9.72,1.4c1.13.21,2,.45,2.6.58l.67.17Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "349.67px 133.904px 0px",
        }}
        id="el3hr5ix46694"
        className="animable"
      />
      <path
        d="M230.24,249.34a5.32,5.32,0,0,1-.32-.66c-.22-.49-.5-1.13-.84-1.93-.19-.43-.39-.89-.6-1.4s-.37-1.1-.58-1.72a39.93,39.93,0,0,1-1.26-4.24c-.19-.8-.39-1.63-.59-2.5s-.3-1.8-.47-2.75a58.42,58.42,0,0,1-.64-6.12,61.61,61.61,0,0,1,4.93-27.55A58,58,0,0,1,232.6,195c.48-.83.9-1.67,1.39-2.42l1.43-2.14a40.76,40.76,0,0,1,2.64-3.54c.41-.5.78-1,1.14-1.41l1.05-1.1,1.46-1.52a4.45,4.45,0,0,1,.53-.51,3.39,3.39,0,0,1-.45.58l-1.39,1.58-1,1.13c-.35.43-.7.92-1.1,1.43a43.57,43.57,0,0,0-2.57,3.57l-1.39,2.14c-.48.75-.88,1.59-1.35,2.42a60.08,60.08,0,0,0-2.67,5.5,68.13,68.13,0,0,0-4,13.39,68.83,68.83,0,0,0-.93,13.95c.17,2.14.26,4.19.6,6.08.15.94.24,1.86.43,2.73s.38,1.7.56,2.5c.31,1.6.81,3,1.17,4.23.2.62.36,1.2.54,1.72s.39,1,.55,1.42l.75,2A3.22,3.22,0,0,1,230.24,249.34Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "233.548px 215.85px 0px",
        }}
        id="elnwd9dcn379n"
        className="animable"
      />
      <path
        d="M280.61,312.26s-.16-.08-.45-.28l-1.23-.88c-1.07-.77-2.58-1.94-4.41-3.43a141.65,141.65,0,0,1-25.18-26.74c-1.38-1.92-2.45-3.49-3.16-4.6-.32-.52-.59-.94-.81-1.29s-.27-.45-.25-.46a2.42,2.42,0,0,1,.34.4l.89,1.23c.76,1.08,1.87,2.62,3.28,4.5a162.54,162.54,0,0,0,25.13,26.68c1.79,1.52,3.26,2.73,4.29,3.55l1.17,1A2.5,2.5,0,0,1,280.61,312.26Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "262.863px 293.42px 0px",
        }}
        id="el3m8gw5nz34m"
        className="animable"
      />
      <path
        d="M367.75,74.9c-.34.79-3.14.36-6.26-1s-5.37-3-5-3.83,3.14-.37,6.25,1S368.08,74.1,367.75,74.9Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "362.116px 72.475px 0px",
        }}
        id="el7lanlk79ii"
        className="animable"
      />
      <path
        d="M364.33,83.37a4.66,4.66,0,0,1-1.89.45,10.71,10.71,0,0,1-8.56-3.22A4.49,4.49,0,0,1,352.76,79c.07-.06.51.53,1.38,1.32A12.36,12.36,0,0,0,358,82.68a12.18,12.18,0,0,0,4.44.77A15.7,15.7,0,0,1,364.33,83.37Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "358.545px 81.4256px 0px",
        }}
        id="elqk8bayq07ed"
        className="animable"
      />
      <path
        d="M345,77.62a3.46,3.46,0,0,1-.55.94,15.79,15.79,0,0,1-1.91,2.25,17.93,17.93,0,0,1-18.18,4.33A15.59,15.59,0,0,1,321.6,84a4,4,0,0,1-.91-.59c.05-.09,1.37.72,3.74,1.39a18.9,18.9,0,0,0,9.47.24,19.15,19.15,0,0,0,8.36-4.47C344.07,78.88,344.89,77.56,345,77.62Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "332.845px 81.8187px 0px",
        }}
        id="el31far9h9nx2"
        className="animable"
      />
      <path
        d="M317.76,89.64a1.91,1.91,0,0,1-.47.23l-1.36.58c-.59.23-1.32.53-2.14.93S312,92.16,311,92.7s-2.14,1.08-3.3,1.77S305.31,95.9,304,96.7a77.76,77.76,0,0,0-7.84,5.93,77,77,0,0,0-6.93,7c-1,1.16-1.91,2.25-2.7,3.34s-1.55,2.09-2.19,3-1.2,1.82-1.69,2.58-.89,1.44-1.21,2l-.75,1.28c-.17.29-.27.43-.29.42a1.68,1.68,0,0,1,.2-.47l.67-1.32c.29-.58.65-1.28,1.13-2.06s1-1.69,1.63-2.64,1.33-2,2.15-3.09,1.72-2.21,2.69-3.39a66.2,66.2,0,0,1,14.87-13c1.3-.8,2.52-1.58,3.72-2.21s2.31-1.22,3.35-1.72,2-.9,2.83-1.26,1.58-.64,2.19-.85l1.4-.49A1.81,1.81,0,0,1,317.76,89.64Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "299.08px 105.945px 0px",
        }}
        id="elni68hph9p5"
        className="animable"
      />
      <path
        d="M321,82.73a35.91,35.91,0,0,0,1-5.67,35,35,0,0,0-.5-5.73,11.34,11.34,0,0,1,1,5.75A11.45,11.45,0,0,1,321,82.73Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "321.772px 77.03px 0px",
        }}
        id="ellnfhyljwmq"
        className="animable"
      />
      <path
        d="M356.62,73.34c.13,0-.09,1-.77,2s-1.49,1.59-1.58,1.48.51-.82,1.15-1.77S356.48,73.28,356.62,73.34Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "355.458px 75.085px 0px",
        }}
        id="elzsbmwa9dog8"
        className="animable"
      />
      <path
        d="M385.8,113.22c-.11,0,.13-1.7-.19-4.4a21.65,21.65,0,0,0-11.53-16.74c-2.41-1.26-4.08-1.64-4.05-1.74a4.69,4.69,0,0,1,1.17.24,19.06,19.06,0,0,1,3,1.18,20.85,20.85,0,0,1,11.73,17,17.57,17.57,0,0,1,0,3.26A4.92,4.92,0,0,1,385.8,113.22Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "378.018px 101.78px 0px",
        }}
        id="el6tfomq7typ8"
        className="animable"
      />
      <g id="elukayixpjtyj">
        <g
          style={{
            opacity: 0.3,
            transformOrigin: "303.636px 84.4499px 0px",
          }}
          className="animable"
        >
          <path
            d="M306.09,84.56c-.16,4.35-1.39,7.83-2.75,7.78s-2.32-3.62-2.16-8,1.4-7.84,2.76-7.78S306.26,80.21,306.09,84.56Z"
            id="elr7burrevhyf"
            style={{
              transformOrigin: "303.636px 84.4499px 0px",
            }}
            className="animable"
          />
        </g>
      </g>
      <path
        d="M303.34,92.34s-.24-.09-.58-.38a3.79,3.79,0,0,1-1.12-1.58,19.26,19.26,0,0,1-.8-6.16,15.75,15.75,0,0,1,1.29-6.08c.75-1.49,1.82-1.88,1.82-1.82a6,6,0,0,0-1.49,2,17.86,17.86,0,0,0-1.1,5.94,22.27,22.27,0,0,0,.64,6,4.05,4.05,0,0,0,.9,1.53C303.18,92.14,303.36,92.31,303.34,92.34Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "302.39px 84.3271px 0px",
        }}
        id="eljlmyzm5hrr"
        className="animable"
      />
      <path
        d="M226.43,178a6.58,6.58,0,0,1-.53-1.2,14.35,14.35,0,0,1-.52-1.45c-.17-.57-.4-1.22-.57-2a35.73,35.73,0,0,1-1-5.23,41.86,41.86,0,0,1-.16-6.51,40.45,40.45,0,0,1,.95-6.44,36.15,36.15,0,0,1,1.58-5.07c.26-.72.56-1.33.81-1.88s.48-1,.68-1.38a5.65,5.65,0,0,1,.68-1.12c.09,0-.8,1.69-1.82,4.51a40.84,40.84,0,0,0-1.47,5.05,45.07,45.07,0,0,0-.89,6.37,43.7,43.7,0,0,0,.12,6.43,39.82,39.82,0,0,0,.84,5.18C225.84,176.19,226.52,177.93,226.43,178Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "225.973px 161.86px 0px",
        }}
        id="el231yjg7nrnh"
        className="animable"
      />
      <g id="el7f17lmksfgr">
        <circle
          cx={229.47}
          cy={153.08}
          r={8.79}
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "229.47px 153.08px 0px",
            transform: "rotate(-76.67deg)",
          }}
          className="animable"
        />
      </g>
      <path
        d="M238.26,153.08c-.07,0,0-.78-.38-2.12a8.73,8.73,0,0,0-3.21-4.72,8.61,8.61,0,0,0-3.62-1.58,8.73,8.73,0,0,0-4.49.39,8.55,8.55,0,0,0-4,3,8.48,8.48,0,0,0,0,10.08,8,8,0,0,0,1.8,1.82,8.25,8.25,0,0,0,2.16,1.17,8.58,8.58,0,0,0,8.11-1.19,8.69,8.69,0,0,0,3.21-4.72c.36-1.34.31-2.12.38-2.12a3.42,3.42,0,0,1,0,.56,6.65,6.65,0,0,1-.2,1.61,8.74,8.74,0,0,1-3.18,5,8.91,8.91,0,0,1-3.77,1.72,9,9,0,0,1-4.74-.37,9,9,0,0,1-4.2-3.13,9,9,0,0,1,0-10.69,8.49,8.49,0,0,1,1.91-1.92,8.74,8.74,0,0,1,2.29-1.22,9,9,0,0,1,4.74-.36A8.9,8.9,0,0,1,234.9,146a8.8,8.8,0,0,1,3.18,5,6.65,6.65,0,0,1,.2,1.61A3.42,3.42,0,0,1,238.26,153.08Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "229.326px 153.133px 0px",
        }}
        id="elb3sk6u52n"
        className="animable"
      />
      <path
        d="M233.86,153.08a4.39,4.39,0,1,1-4.39-4.39A4.39,4.39,0,0,1,233.86,153.08Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "229.47px 153.08px 0px",
        }}
        id="eli03zazbcuvs"
        className="animable"
      />
      <path
        d="M233.86,153.08c-.05,0,0-.39-.23-1.05a4.41,4.41,0,0,0-1.61-2.29,4.23,4.23,0,0,0-4-.56,4.16,4.16,0,0,0,0,7.8,4.23,4.23,0,0,0,4-.55,4.46,4.46,0,0,0,1.61-2.3c.19-.66.18-1,.23-1s0,.1,0,.29a3,3,0,0,1-.08.81,4.33,4.33,0,0,1-1.58,2.54,4.55,4.55,0,0,1-4.35.71,4.62,4.62,0,0,1,0-8.7,4.55,4.55,0,0,1,4.35.71,4.33,4.33,0,0,1,1.58,2.54,3,3,0,0,1,.08.82C233.89,153,233.88,153.08,233.86,153.08Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "229.334px 153.13px 0px",
        }}
        id="el7b481t2sh2f"
        className="animable"
      />
      <path
        d="M248.79,126.3a14.41,14.41,0,0,0-3.08-3.68,4.26,4.26,0,0,0-7.16,2.56,13.74,13.74,0,0,0-.08,4.48l3.16-2.58a14.11,14.11,0,0,0,5.18,4,2.41,2.41,0,0,0,2.95-1.09C250.26,128.73,249.45,127.3,248.79,126.3Z"
        style={{
          fill: "rgb(162, 103, 96)",
          transformOrigin: "244.12px 126.341px 0px",
        }}
        id="eldcur47q7234"
        className="animable"
      />
      <path
        d="M252.35,123a14,14,0,0,0-3.07-3.67,4.26,4.26,0,0,0-7.17,2.55,14.31,14.31,0,0,0-.08,4.48l3.16-2.58a14.19,14.19,0,0,0,5.18,4,2.41,2.41,0,0,0,2.95-1.09C253.82,125.45,253,124,252.35,123Z"
        style={{
          fill: "rgb(162, 103, 96)",
          transformOrigin: "247.683px 123.041px 0px",
        }}
        id="el0jlqhnl7bzif"
        className="animable"
      />
      <path
        d="M255.92,119.74a14.19,14.19,0,0,0-3.08-3.67,4.26,4.26,0,0,0-7.16,2.56,14.25,14.25,0,0,0-.08,4.47l3.16-2.57a14.19,14.19,0,0,0,5.18,4,2.39,2.39,0,0,0,2.95-1.09C257.39,122.17,256.58,120.74,255.92,119.74Z"
        style={{
          fill: "rgb(162, 103, 96)",
          transformOrigin: "251.253px 119.793px 0px",
        }}
        id="elgcqurvbyqcg"
        className="animable"
      />
      <path
        d="M147.76,419.45l-27.07,24.76L151.32,478c3.06-3.12-6.3-26.5-6.3-26.5l16.91-16.36Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "141.31px 448.725px 0px",
        }}
        id="elm9n7zll7p0s"
        className="animable"
      />
      <path
        d="M137,439.75a1.87,1.87,0,0,0-2.44.47,1.81,1.81,0,0,0,.45,2.43,2,2,0,0,0,2.58-.52,1.86,1.86,0,0,0-.74-2.47"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "136.036px 441.201px 0px",
        }}
        id="el8im13vahego"
        className="animable"
      />
      <path
        d="M120.69,444.21l2.83-2.62,28.21,33.66s.7,2.11-.52,2.89Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "136.31px 459.865px 0px",
        }}
        id="elmcsuitnc49"
        className="animable"
      />
      <path
        d="M145.69,451.93c-.17.15-1-.61-2.26-.94s-2.36-.14-2.43-.35,1.11-.83,2.63-.4S145.87,451.83,145.69,451.93Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "143.357px 451.02px 0px",
        }}
        id="el0daja7hpsgwh"
        className="animable"
      />
      <path
        d="M147.43,456.81c-.12.18-1.05-.28-2.26-.21s-2.09.58-2.23.41.62-1.11,2.12-1.17S147.59,456.66,147.43,456.81Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "145.185px 456.441px 0px",
        }}
        id="elrabv79j4x4"
        className="animable"
      />
      <path
        d="M145,462.67c-.21-.14.28-1,1.74-1.49,1.28-.4,2.34.05,2.27.25s-1,.15-2,.49S145.18,462.82,145,462.67Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "146.983px 461.857px 0px",
        }}
        id="elz6gx0ndqltc"
        className="animable"
      />
      <path
        d="M149.41,448c-.22.07-.68-.89-1.58-1.77s-1.87-1.34-1.8-1.55,1.28-.05,2.34,1S149.61,448,149.41,448Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "147.754px 446.302px 0px",
        }}
        id="elp3dcvhcaxq"
        className="animable"
      />
      <path
        d="M152.69,443.58c-.07.07-.76-.49-1.52-1.7a10.79,10.79,0,0,1-1.43-3.71,2.6,2.6,0,0,1-.06-.87,1,1,0,0,1,.81-.87,1.23,1.23,0,0,1,1,.38,3,3,0,0,1,.49.72,8.11,8.11,0,0,1,1,3.87,3.75,3.75,0,0,1-.48,2.24c-.12,0,.05-.87-.07-2.22a8.76,8.76,0,0,0-.52-2.28,7.67,7.67,0,0,0-.58-1.24c-.23-.45-.5-.75-.74-.7-.09,0-.12,0-.16.21a2.17,2.17,0,0,0,.05.64,13.57,13.57,0,0,0,.3,1.36,12.66,12.66,0,0,0,.85,2.2A17.23,17.23,0,0,1,152.69,443.58Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "151.333px 440.033px 0px",
        }}
        id="ela0b5hvswfm"
        className="animable"
      />
      <path
        d="M152.26,443.58c-.08,0,.22-.9,1.23-1.93a7.6,7.6,0,0,1,2.07-1.44,6.8,6.8,0,0,1,1.42-.5,1.87,1.87,0,0,1,1.83.3,1.06,1.06,0,0,1,.17,1.14,3,3,0,0,1-.47.73,4.85,4.85,0,0,1-1.14,1,5.31,5.31,0,0,1-2.4.86,3,3,0,0,1-2.26-.44,20.74,20.74,0,0,0,2.18-.1,5.28,5.28,0,0,0,2.08-.91,4.85,4.85,0,0,0,.95-.92c.31-.37.48-.77.32-.87a1.28,1.28,0,0,0-1.09-.09,7.32,7.32,0,0,0-1.3.41,8.25,8.25,0,0,0-2,1.2C152.83,442.91,152.37,443.65,152.26,443.58Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "155.661px 441.697px 0px",
        }}
        id="el0enyodp8ya48"
        className="animable"
      />
      <path
        d="M141.23,443.31l.34,36.68,45.64-.19c-.28-4.36-23.93-13-23.93-13l.74-23.52Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "164.22px 461.635px 0px",
        }}
        id="elmflz4wct6yl"
        className="animable"
      />
      <path
        d="M149.15,464.87a1.87,1.87,0,0,0-1.28,2.13,1.8,1.8,0,0,0,2.11,1.29,2,2,0,0,0,1.34-2.27,1.85,1.85,0,0,0-2.33-1.09"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "149.596px 466.579px 0px",
        }}
        id="el6tfyhymit9c"
        className="animable"
      />
      <path
        d="M141.57,480.07l-.06-3.93,43.9,1.49s2,.89,1.8,2.32Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "164.367px 478.105px 0px",
        }}
        id="elxh4dtd2hbqg"
        className="animable"
      />
      <path
        d="M164,466.55c0,.22-1.13.33-2.22,1.05s-1.67,1.66-1.88,1.57.12-1.37,1.46-2.22S164.06,466.35,164,466.55Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "161.922px 467.765px 0px",
        }}
        id="el3s28z6i2r34"
        className="animable"
      />
      <path
        d="M168.81,468.51c.05.22-.91.6-1.66,1.55s-1,1.94-1.19,1.93-.37-1.27.59-2.43S168.81,468.3,168.81,468.51Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "167.31px 470.206px 0px",
        }}
        id="elwa8cj9552oc"
        className="animable"
      />
      <path
        d="M171.55,474.23c-.2,0-.51-1.07,0-2.29s1.61-1.71,1.71-1.53-.55.84-1,1.86S171.78,474.21,171.55,474.23Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "172.271px 472.302px 0px",
        }}
        id="el8p8qvo1g6dl"
        className="animable"
      />
      <path
        d="M163.59,461.17c-.09.21-1.12-.1-2.38,0s-2.24.5-2.35.31.82-1,2.31-1.08S163.7,461,163.59,461.17Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "161.225px 460.962px 0px",
        }}
        id="elz94pruu25ki"
        className="animable"
      />
      <path
        d="M143.52,234.05s-6.39,6.85-9.54,13.41S126,268,126,268s-2,20.39-.68,30.45,4.46,54.68,4.46,54.68,4.49,74.7,7.82,104l1.42,6.44,25.73-4.56h0l5.7-135.1,15.7-89.31Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "155.51px 348.81px 0px",
        }}
        id="elpavtxpn145"
        className="animable"
      />
      <path
        d="M176.38,239.81a2.92,2.92,0,0,0-1-1.48,1.88,1.88,0,0,0-1.76-.18,1.83,1.83,0,0,0,.06,3.41,1.9,1.9,0,0,0,1.76-.24c.89-.67.82-1.55.93-1.51s.11.18.07.54a2.14,2.14,0,0,1-.73,1.32,2.32,2.32,0,0,1-2.22.43,2.37,2.37,0,0,1-.07-4.49,2.31,2.31,0,0,1,2.22.36,2.17,2.17,0,0,1,.78,1.29C176.48,239.62,176.42,239.81,176.38,239.81Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "174.154px 239.844px 0px",
        }}
        id="elz9phdocczzq"
        className="animable"
      />
      <path
        d="M206.25,252.62S215.69,338.26,217,353s-52,93.14-52,93.14l-22.53-26.62,34.37-63.88L165.29,292l15.23-57.41,23.69.28Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "179.747px 340.365px 0px",
        }}
        id="elut7ya5aw5o"
        className="animable"
      />
      <path
        d="M133.67,436.57a17.3,17.3,0,0,0,.18,1.87c.16,1.23.46,3,.89,5.36.85,4.66,2.24,11.42,4.1,19.87l0,.17.18,0,25.74-4.51.2,0v-.19c.71-17.66,1.57-38.77,2.48-61.41.95-24.36,1.83-46.94,2.56-65.47v0c1.93-14.88,3.53-27.19,4.64-35.8.54-4.28,1-7.64,1.26-10,.13-1.12.24-2,.31-2.61s.08-.9.08-.9-.06.3-.15.89-.22,1.48-.38,2.6c-.33,2.32-.79,5.67-1.39,9.94-1.16,8.61-2.83,20.91-4.84,35.78h0c-.75,18.53-1.67,41.11-2.66,65.47-.88,22.64-1.71,43.75-2.4,61.41l.21-.24L139,463.44l.21.14c-1.91-8.43-3.35-15.17-4.27-19.82-.46-2.32-.79-4.12-1-5.34-.11-.61-.17-1.07-.21-1.38S133.67,436.57,133.67,436.57Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "154.98px 373.395px 0px",
        }}
        id="ely0h8lmf85r"
        className="animable"
      />
      <path
        d="M172.64,268.88a7.85,7.85,0,0,1,1.41.07,6.48,6.48,0,0,0,3.62-.62,3.35,3.35,0,0,0,1.45-1.95,13.65,13.65,0,0,0,.44-2.95c.19-2.13.37-4.48.53-6.95.33-4.94.52-9.42.63-12.66.05-1.52.1-2.81.14-3.84a5.32,5.32,0,0,1,.12-1.41,6.37,6.37,0,0,1,.11,1.41c0,.91.06,2.22.06,3.85,0,3.25-.12,7.74-.45,12.69-.16,2.47-.36,4.83-.58,7a13.06,13.06,0,0,1-.52,3.05,3.8,3.8,0,0,1-1.71,2.16,4.8,4.8,0,0,1-2.19.57,9.33,9.33,0,0,1-1.68-.09A4.87,4.87,0,0,1,172.64,268.88Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "176.895px 253.938px 0px",
        }}
        id="elg7zkhf6cmh"
        className="animable"
      />
      <path
        d="M205.22,252.68a8.92,8.92,0,0,1-2.46-1.3,25.49,25.49,0,0,1-8.79-10,8.68,8.68,0,0,1-1-2.61c.18-.09,1.71,3.92,5.16,7.8S205.33,252.51,205.22,252.68Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "199.096px 245.724px 0px",
        }}
        id="elr2boyal27xe"
        className="animable"
      />
      <path
        d="M122.09,265.91c.68-8.32,4.49-23.47,6.08-35.62,4.56-34.87,7.17-86.24,7.17-86.24l16.19-4.58,8.39-11.8,25.43,3.57,8.13,9.55,13.36,8.05,5.58,86.62,9.72,110.91s-14.12-.95-39.61-.17c-48.82,1.49-61,2.2-61,2.2S120,290.72,122.09,265.91Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "171.565px 238.035px 0px",
        }}
        id="eljgtdtqa9959"
        className="animable"
      />
      <path
        d="M193.58,141.2a2.36,2.36,0,0,1,.36.49c.24.39.54.88.92,1.47l3.3,5.43.21.35-.4-.06-6.21-.9.19-.4c1.33,1.2,2.74,2.49,4.16,3.92a14.47,14.47,0,0,1,1,1.14l.13.16c0,.09.07.06.13.24a1,1,0,0,1-.06.53,7.32,7.32,0,0,1-.3.75c-.44,1-.95,1.91-1.47,2.86-3.64,6.5-7.22,12.2-9.8,16.34-1.3,2.06-2.37,3.72-3.11,4.86l-.87,1.31c-.21.3-.32.45-.34.44a2,2,0,0,1,.25-.5l.79-1.35c.73-1.24,1.74-2.91,3-4.95,2.5-4.18,6-9.92,9.66-16.4.52-1,1-1.88,1.46-2.82.1-.23.2-.47.28-.7a.47.47,0,0,0,0-.16s0-.05,0-.06,0,0,.09,0l.07,0h0l-.15.09h0l0,0,0-.07-.11-.14c-.31-.38-.66-.75-1-1.11-1.4-1.42-2.8-2.72-4.11-3.92l-.57-.53.76.12,6.19,1-.19.29-3.15-5.52-.84-1.52A3.6,3.6,0,0,1,193.58,141.2Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "189.895px 160.665px 0px",
        }}
        id="el2v9tugmxqkg"
        className="animable"
      />
      <path
        d="M208.56,160.68c.14,0,1,14.77,2,33s1.59,33,1.45,33.05-1-14.77-2-33S208.42,160.68,208.56,160.68Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "210.285px 193.705px 0px",
        }}
        id="elen81ivrc0lc"
        className="animable"
      />
      <path
        d="M162.46,127.85a10.17,10.17,0,0,0-2.37,7.85c.47,5,4,14.43,6.17,17.28s15.21,27.15,15.21,27.15l6.65-34.77.42-11.38L186,131.42Z"
        style={{
          fill: "rgb(255, 114, 94)",
          transformOrigin: "174.277px 153.99px 0px",
        }}
        id="elt7py7youyur"
        className="animable"
      />
      <path
        d="M182.63,346c0,3.25-.72-39.79-1.25-84.86s-.82-81.64-.68-81.65.69,36.55,1.21,81.64S182.63,345.9,182.63,346Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "181.647px 262.832px 0px",
        }}
        id="elt6m90y6go2"
        className="animable"
      />
      <path
        d="M204.9,239.14a10.65,10.65,0,0,1-6.86-2.33c-6.54-5.24-7.39-18-8.15-29.33-.12-1.73-.23-3.41-.36-5-.53-6.47-10.59-39-10.7-39.3l2.87-.89c.42,1.35,10.26,33.15,10.82,39.94.13,1.61.25,3.3.36,5.05.68,10.15,1.53,22.78,7,27.19a8.29,8.29,0,0,0,6.8,1.52c10.83-1.66,9.6-22.52,8.94-33.72a64.24,64.24,0,0,1-.21-6.49c.44-6.87,2.08-18.58,4.33-23.08,2-4,7-18.26,7.09-18.4l2.83,1c-.21.6-5.14,14.55-7.24,18.75-1.95,3.9-3.58,15.25-4,21.94-.07,1.2.06,3.48.22,6.11.71,12.16,2,34.8-11.48,36.87A15,15,0,0,1,204.9,239.14Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "204.245px 196.721px 0px",
        }}
        id="elf5ocdydzb6k"
        className="animable"
      />
      <path
        d="M179.36,163.13c-4.21,0-5.87-5-6.8-7.73-.16-.49-.31-.93-.45-1.3-.73-1.86-3.19-4.56-4.07-5.44l2.12-2.13c.37.37,3.65,3.7,4.74,6.48.16.4.32.89.5,1.43,1.34,4,2.47,6.05,4.57,5.62,1.53-.31,1.67-1.08,1.58-4a13.51,13.51,0,0,1,.32-4.17,20.45,20.45,0,0,1,3.16-6.29l2.36,1.85a17.8,17.8,0,0,0-2.64,5.3,11.07,11.07,0,0,0-.2,3.22c.08,2.44.19,6.14-4,7A5.87,5.87,0,0,1,179.36,163.13Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "177.715px 154.365px 0px",
        }}
        id="el2g0hl4ybomk"
        className="animable"
      />
      <g id="elxabbsdghva">
        <g
          style={{
            opacity: 0.3,
            transformOrigin: "166.05px 223.686px 0px",
          }}
          className="animable"
        >
          <path
            d="M128.9,226.14s8.9,14,18,14.25c12,.27,56.3-29.41,56.3-29.41l-2.1-4-70.89,5Z"
            id="elfrhr413igid"
            style={{
              transformOrigin: "166.05px 223.686px 0px",
            }}
            className="animable"
          />
        </g>
      </g>
      <path
        d="M135.45,143.89a18.74,18.74,0,0,0-11,7.34h0c-3.38,4.79-4.32,11.61-3.43,22.41,1.2,14.62,9.37,38.74,11.4,45.78,3.66,12.73,11.61,15.93,20.58,14.19s53.9-30.35,53.9-30.35l-11.37-19.88-42.73,18.13-10-32.95"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "163.802px 188.969px 0px",
        }}
        id="elddzaxjbpcjg"
        className="animable"
      />
      <path
        d="M142.89,168.56s.08.19.2.56.3,1,.53,1.68c.46,1.5,1.14,3.69,2,6.51,1.73,5.68,4.24,13.9,7.37,24.15l-.23-.11,42.71-18.19.19-.08.11.18,11.38,19.87.12.21-.2.13c-9.34,5.92-19.4,12.12-29.93,18.27q-6.21,3.63-12.4,6.94l-3.09,1.61-3.13,1.51c-1,.5-2.12.91-3.17,1.36A16.43,16.43,0,0,1,152,234a19.42,19.42,0,0,1-6.76-.08,14.17,14.17,0,0,1-6-2.78,17,17,0,0,1-4.19-5,27.62,27.62,0,0,1-2.52-5.82c-4.9-15.86-9.33-30.21-11.15-42.68a77.8,77.8,0,0,1-.74-8.94,49.22,49.22,0,0,1,.33-8,24,24,0,0,1,1.82-6.73,17.75,17.75,0,0,1,3.27-4.85,18.24,18.24,0,0,1,6.71-4.46,16.52,16.52,0,0,1,2.7-.83s-.23.09-.68.22-1.13.36-2,.71a18.49,18.49,0,0,0-6.6,4.5,17.68,17.68,0,0,0-3.2,4.81,24,24,0,0,0-1.75,6.67,48.77,48.77,0,0,0-.29,7.95,79.53,79.53,0,0,0,.77,8.9c1.87,12.41,6.33,26.74,11.25,42.58a27.28,27.28,0,0,0,2.48,5.72,16.73,16.73,0,0,0,4.08,4.83,13.72,13.72,0,0,0,5.83,2.68,19.17,19.17,0,0,0,6.59.07,17.27,17.27,0,0,0,3.23-.85c1-.45,2.1-.85,3.14-1.34l3.1-1.51,3.09-1.61q6.17-3.3,12.37-6.93c10.53-6.14,20.59-12.34,29.93-18.24l-.09.33c-3.94-6.9-7.75-13.57-11.35-19.89l.3.1L152.9,201.67l-.17.07-.06-.18c-3.06-10.27-5.52-18.51-7.22-24.2-.83-2.83-1.48-5-1.92-6.53l-.49-1.69Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "163.935px 189.044px 0px",
        }}
        id="elyj247v4syt"
        className="animable"
      />
      <path
        d="M195.57,183.38s9.61-9.93,13.17-13.06,17.48-10.57,19.53-10.36,1.08,2.59,0,4-11.33,6.69-13.06,9.07l.54.86s6.26-2.91,8-3.67,4.53,1.19,3.34,3.24l-1.62,1.62s2,1.4,1.41,3.13-3.13,3-3.13,3,2.37,1.62.21,4.75-13.49,8.52-14.67,9.06a41.75,41.75,0,0,1-6.11,1.19Z"
        style={{
          fill: "rgb(162, 103, 96)",
          transformOrigin: "212.52px 178.083px 0px",
        }}
        id="elmz48qru5oe"
        className="animable"
      />
      <path
        d="M144.14,218.73a2.48,2.48,0,0,1,0-.79,15.67,15.67,0,0,1,.25-2.11,24.21,24.21,0,0,1,6.29-12.4,17.71,17.71,0,0,1,1.56-1.46,2.79,2.79,0,0,1,.64-.45c.06.07-.76.82-1.92,2.15a27.89,27.89,0,0,0-6.21,12.23C144.35,217.63,144.23,218.73,144.14,218.73Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "148.496px 210.125px 0px",
        }}
        id="elpxda5t0u0sk"
        className="animable"
      />
      <path
        d="M214.79,261.21s0,.06,0,.2,0,.36.07.62c.06.59.14,1.4.24,2.44.21,2.18.51,5.3.88,9.19.72,7.91,1.73,18.95,2.89,31.63l0,.26-.26,0a19.54,19.54,0,0,1-13.09-4.08,18.28,18.28,0,0,1-4.1-4.42,18.91,18.91,0,0,1-2.37-5.35,26.47,26.47,0,0,1-.59-5.6c-.06-1.83-.12-3.62-.18-5.36-.22-7-.42-13.24-.58-18.5v-.18h.18l12.39-.67,3.34-.16.85,0a1.1,1.1,0,0,1,.28,0l-.31,0-.89.08-3.37.25-12.27.87.17-.19c.2,5.26.44,11.53.7,18.49.06,1.75.13,3.53.2,5.36a25.55,25.55,0,0,0,.58,5.49,18.31,18.31,0,0,0,2.32,5.2,17.79,17.79,0,0,0,4,4.29,19,19,0,0,0,12.74,4l-.24.28c-1.06-12.63-2-23.62-2.64-31.49-.31-3.91-.56-7.05-.74-9.25-.08-1.07-.14-1.9-.18-2.51,0-.26,0-.48,0-.65S214.79,261.21,214.79,261.21Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "208.285px 283.396px 0px",
        }}
        id="elnvvsjm6j82"
        className="animable"
      />
      <path
        d="M131.16,261v.39c0,.28,0,.65,0,1.12,0,1-.07,2.44-.12,4.26-.12,3.7-.29,9-.5,15.54-.05,3.25-.57,6.91.7,10.57a18.07,18.07,0,0,0,13.25,12.1,18.21,18.21,0,0,0,6.83.16,18,18,0,0,0,11.86-7.53,19.18,19.18,0,0,0,2.21-4.44,18,18,0,0,0,.9-4.78c.11-3.25.1-6.46.15-9.56.08-6.21.16-12.07.23-17.43l.22.23L141,261.17l-7.27-.14-1.93,0-.51,0h2.35l7.22,0,26,.18h.23v.22c-.05,5.37-.1,11.22-.17,17.43,0,3.11,0,6.3-.13,9.58a18.58,18.58,0,0,1-.92,4.92,19.92,19.92,0,0,1-2.28,4.57,18.51,18.51,0,0,1-12.21,7.75,19,19,0,0,1-7-.18A18.54,18.54,0,0,1,130.81,293a17.53,17.53,0,0,1-.84-5.57c0-1.81.13-3.54.18-5.19.3-6.56.54-11.89.71-15.6.08-1.81.15-3.22.2-4.21,0-.46.05-.81.06-1.08A1.66,1.66,0,0,1,131.16,261Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "148.529px 283.461px 0px",
        }}
        id="el1omhenvvotp"
        className="animable"
      />
      <path
        d="M166.87,271.57c0,.15-8,.26-17.94.26s-17.93-.11-17.93-.26,8-.26,17.93-.26S166.87,271.43,166.87,271.57Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "148.935px 271.57px 0px",
        }}
        id="elj00w77nvcyc"
        className="animable"
      />
      <path
        d="M216.05,271.59a73.45,73.45,0,0,1-8.77.8,73.61,73.61,0,0,1-8.8.27,74.84,74.84,0,0,1,8.77-.79A75,75,0,0,1,216.05,271.59Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "207.265px 272.127px 0px",
        }}
        id="eleuizmjy8rya"
        className="animable"
      />
      <g id="el3qqcnk26pzc">
        <g
          style={{
            opacity: 0.3,
            transformOrigin: "148.365px 301.405px 0px",
          }}
          className="animable"
        >
          <path
            d="M148.88,305.45c-7.13.43-13.64-3.89-17-10.17l-.48-1.33c.29,5.66,3.9,10.39,8.84,13.17a16.87,16.87,0,0,0,25.09-13.59A19.31,19.31,0,0,1,148.88,305.45Z"
            id="el5phrbroucj2"
            style={{
              transformOrigin: "148.365px 301.405px 0px",
            }}
            className="animable"
          />
        </g>
      </g>
      <path
        d="M151.63,139.32c.08.8-3.22,12.89-3.22,12.89l7.33-1.45s-3.51,5.06-3.66,6.72,28.62,22.05,28.62,22.05"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "164.555px 159.425px 0px",
        }}
        id="elmg2u0qq712k"
        className="animable"
      />
      <path
        d="M180.7,179.53a2.83,2.83,0,0,1-.56-.33l-1.56-1.06c-1.35-.92-3.29-2.28-5.68-4s-5.21-3.74-8.32-6-6.52-4.84-10-7.7a27.76,27.76,0,0,1-2.26-2.06,2.73,2.73,0,0,1-.5-.69c-.07-.3,0-.35,0-.51s.08-.25.11-.38a11.37,11.37,0,0,1,.61-1.37,48.8,48.8,0,0,1,2.95-4.79l.25.38-7.34,1.41-.33.07.09-.33c1-3.85,1.92-7,2.55-9.33s.87-3.5.87-3.5a15.76,15.76,0,0,1-.64,3.56c-.52,2.25-1.34,5.47-2.38,9.38l-.24-.26,7.33-1.48.58-.12-.34.5a49.31,49.31,0,0,0-2.89,4.74,9.5,9.5,0,0,0-.58,1.31,2.23,2.23,0,0,0-.09.32l0,.16v.06h-.08c.14,0,.05,0,.08,0a2.23,2.23,0,0,0,.39.51,26.91,26.91,0,0,0,2.21,2c3.43,2.84,6.84,5.39,9.93,7.72l8.25,6.12,5.57,4.12,1.51,1.13A2.66,2.66,0,0,1,180.7,179.53Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "164.385px 159.435px 0px",
        }}
        id="elq2t9x61vuz"
        className="animable"
      />
      <g id="elgi9qvh69kr">
        <g
          style={{
            opacity: 0.3,
            transformOrigin: "161.757px 159.28px 0px",
          }}
          className="animable"
        >
          <path
            d="M151.27,141.2l-5.21,10.94a1.85,1.85,0,0,0,2,2.61l3.43-.66-1.16,2.29a3.73,3.73,0,0,0,1.36,4.85l25.94,16.13s-26.24-18.67-25.44-20.43,3.53-6.17,3.53-6.17l-7.33,1.45Z"
            id="elmx0qcwtu3jq"
            style={{
              transformOrigin: "161.757px 159.28px 0px",
            }}
            className="animable"
          />
        </g>
      </g>
      <path
        d="M162.78,67.46c-3.54-3.41-11.66-2.33-13.43.18a6.23,6.23,0,0,0-8,3.24l-8.55,2.47a9.06,9.06,0,0,0-4.05,2c-1.07,1.08-1.48,3-.47,4.1-3,1-3.9,5.62-1.49,7.67a3.29,3.29,0,0,0,.8,4.72,33,33,0,0,0-4.95,10,6.66,6.66,0,0,0-.13,4.59c.64,1.43,2.63,2.32,3.84,1.32a3.85,3.85,0,0,0,.09,4.16c-1.46.14-1.75,2.43-.67,3.43s2.72,1,4.18.88,3-.31,4.31.44a1.37,1.37,0,0,1-.41,1,6,6,0,0,0-.81,8.3l.53.64c.92,1.15,3.1,2.12,4.45,2.72,3.43,1.51,5.39,1,9.13,1.34-.86,2.46,5.5,7.35,12,1.7A132.8,132.8,0,0,0,197.42,135c2-.12,4.45-.56,5.23-2.44a5.05,5.05,0,0,0,4.54-1.82,15,15,0,0,0,2.44-4.47,8.87,8.87,0,0,0,5.84-8.38,11,11,0,0,0,3.61-8,6.42,6.42,0,0,0,3.1-8.89,39,39,0,0,0-5-11.7c2.29-.65,3-3.85,1.86-6s-3.31-3.38-5.4-4.53c1.77.35,3.14-1.93,2.61-3.66s-2.18-2.83-3.78-3.65a32.75,32.75,0,0,0-7.42-2.74c-1-3-5.17-6.24-8.13-7.41-11.92-4.71-20.11-5.56-34.14,6.2"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "172.546px 96.7249px 0px",
        }}
        id="el46s43on8vco"
        className="animable"
      />
      <path
        d="M196.68,110a4.14,4.14,0,0,1,1.56-1.24h-.12a2,2,0,0,1,.35-.09,1.65,1.65,0,0,1,1.31,0h0a3.1,3.1,0,0,1,1.81,1.32,3.64,3.64,0,0,1-.09,3.78,2.79,2.79,0,0,1-5.19-.49A3.47,3.47,0,0,1,196.68,110Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "199.067px 111.929px 0px",
        }}
        id="elgybysekjxyr"
        className="animable"
      />
      <path
        d="M196.42,87.38c-1.44-7.9-7.87-17-15.7-15.26l-24,9.19a4.71,4.71,0,0,0-3.62,5.23l7.4,51.61,19.12,14.06h0c.15-1.05,8.41-14.06,8.41-14.06.42-3.85.86-8.1.86-8.08s10-2.89,10.51-16.41C199.64,106.94,198,96.16,196.42,87.38Z"
        style={{
          fill: "rgb(162, 103, 96)",
          transformOrigin: "176.24px 112.057px 0px",
        }}
        id="elusr1eiomo4"
        className="animable"
      />
      <path
        d="M195.07,98.56a1.71,1.71,0,0,1-1.44,1.91,1.63,1.63,0,0,1-1.93-1.32,1.72,1.72,0,0,1,1.43-1.92A1.65,1.65,0,0,1,195.07,98.56Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "193.385px 98.851px 0px",
        }}
        id="el58muo5iiivt"
        className="animable"
      />
      <path
        d="M194.74,93.29c-.18.25-1.58-.56-3.41-.33s-3.07,1.29-3.29,1.09.06-.51.59-1a4.73,4.73,0,0,1,2.6-1.15,4.53,4.53,0,0,1,2.75.54C194.6,92.8,194.84,93.18,194.74,93.29Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "191.363px 92.971px 0px",
        }}
        id="elyr4twucv9bb"
        className="animable"
      />
      <path
        d="M178.39,100.15a1.71,1.71,0,0,1-1.43,1.91,1.64,1.64,0,0,1-1.94-1.33,1.72,1.72,0,0,1,1.44-1.91A1.63,1.63,0,0,1,178.39,100.15Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "176.706px 100.44px 0px",
        }}
        id="el0br102uuwbfm"
        className="animable"
      />
      <path
        d="M176.79,95.76c-.19.25-1.59-.55-3.42-.33s-3.06,1.3-3.29,1.1.06-.52.59-1a4.67,4.67,0,0,1,2.6-1.16,4.57,4.57,0,0,1,2.76.55C176.64,95.27,176.88,95.65,176.79,95.76Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "173.404px 95.4469px 0px",
        }}
        id="elmyed5kfs29"
        className="animable"
      />
      <path
        d="M185,108.55a12.61,12.61,0,0,1,2.91-.89c.46-.1.89-.24.93-.57a2.33,2.33,0,0,0-.47-1.35l-1.81-3.4c-2.52-4.84-4.4-8.84-4.2-8.94s2.39,3.74,4.91,8.58c.61,1.2,1.2,2.34,1.75,3.43a2.68,2.68,0,0,1,.46,1.8,1.17,1.17,0,0,1-.68.78,3,3,0,0,1-.79.2A11.52,11.52,0,0,1,185,108.55Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "185.92px 100.975px 0px",
        }}
        id="el9bbawqha18w"
        className="animable"
      />
      <path
        d="M188.87,130.07a34,34,0,0,1-18.33-2.63s4.1,9.26,17.88,6.91Z"
        style={{
          fill: "rgb(123, 75, 69)",
          transformOrigin: "179.705px 131.086px 0px",
        }}
        id="elpoawc964i3d"
        className="animable"
      />
      <path
        d="M185.28,112.94a4.54,4.54,0,0,0-3.94-1.53,2.94,2.94,0,0,0-2.25,1.6,2.71,2.71,0,0,0,3.49,3.67,6.58,6.58,0,0,0,2.5-2,2.15,2.15,0,0,0,.5-.75,1,1,0,0,0-.18-.92"
        style={{
          fill: "rgb(123, 75, 69)",
          transformOrigin: "182.224px 114.135px 0px",
        }}
        id="elkj61si8ltz"
        className="animable"
      />
      <path
        d="M179.8,110.46c.3,0,.54,1.93,2.41,3.14s3.95.74,4,1c0,.12-.42.44-1.32.57a5,5,0,0,1-3.33-.74,4.29,4.29,0,0,1-1.88-2.65C179.5,111,179.66,110.46,179.8,110.46Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "182.905px 112.836px 0px",
        }}
        id="el66ds0g8dkh8"
        className="animable"
      />
      <path
        d="M176.7,88.13c-.12.52-2,.5-4.09,1s-3.79,1.31-4.13.89c-.15-.2.1-.7.74-1.26a6.87,6.87,0,0,1,3-1.45,7,7,0,0,1,3.29,0C176.31,87.54,176.75,87.88,176.7,88.13Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "172.571px 88.6254px 0px",
        }}
        id="elhopyiq352hh"
        className="animable"
      />
      <path
        d="M193.35,87.06c-.27.46-1.58.18-3.1.33s-2.77.62-3.12.22c-.15-.2,0-.64.52-1.1a4.26,4.26,0,0,1,2.44-1,4.35,4.35,0,0,1,2.57.54C193.24,86.44,193.47,86.84,193.35,87.06Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "190.228px 86.628px 0px",
        }}
        id="elkrsqp4aa13"
        className="animable"
      />
      <path
        d="M202.88,93.34a9.17,9.17,0,0,0-2.63-5.57,33.08,33.08,0,0,1-2.64-2.2C196,83.71,196,81,195.16,78.62a10.07,10.07,0,0,0-6.72-6.31c-2.57-.71-5.39-.38-7.82-1.45-1.8-.8-3.24-2.29-5.08-3-3.59-1.33-7.49.75-10.63,2.94-.46,2.65,1.36,4.79,3.1,6.84a9.36,9.36,0,0,0,7.13,3.23c2.09,0,4.48-.68,6.05.7s1.26,4.24,2.66,5.94c2,2.42,6,1.15,8.85,2.53,2.18,1.07,3.24,3.5,4.45,5.6s3.19,4.24,5.6,4A27.41,27.41,0,0,0,202.88,93.34Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "183.92px 83.5503px 0px",
        }}
        id="elvikvgku0l1f"
        className="animable"
      />
      <path
        d="M170.45,75.18a47.43,47.43,0,0,0-17.6,4.53,8.67,8.67,0,0,0-4.17,3.35,8.59,8.59,0,0,0-.59,4.69c.43,5,2.88,10.94,5.12,15.41l6.51,3.27c4.71-1.48,1.9-9.6,1.36-13.74a9.81,9.81,0,0,0,5.09-9.07A10.89,10.89,0,0,0,170.45,75.18Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "159.219px 90.805px 0px",
        }}
        id="elfrrrl1g6mi"
        className="animable"
      />
      <path
        d="M159.5,104.65c-.4-2.84-3.94-3.14-6.29-1.49-1.28.91-2.18,2.58-1.78,5.59,1,8,8.91,5.32,8.89,5.09S160,108,159.5,104.65Z"
        style={{
          fill: "rgb(162, 103, 96)",
          transformOrigin: "155.827px 108.304px 0px",
        }}
        id="elhl2dd4xyyt5"
        className="animable"
      />
      <path
        d="M157.47,111.12s-.13.12-.35.26a1.42,1.42,0,0,1-1.05.15c-.89-.2-1.78-1.45-2-2.89a4.68,4.68,0,0,1,.13-2.06,1.66,1.66,0,0,1,.91-1.22.74.74,0,0,1,.88.28c.14.21.11.38.15.39s.15-.16.05-.49a1,1,0,0,0-.39-.46,1.07,1.07,0,0,0-.8-.1,2,2,0,0,0-1.3,1.44,4.86,4.86,0,0,0-.19,2.3c.27,1.62,1.29,3,2.5,3.21a1.51,1.51,0,0,0,1.25-.38C157.48,111.31,157.5,111.13,157.47,111.12Z"
        style={{
          fill: "rgb(123, 75, 69)",
          transformOrigin: "155.465px 108.446px 0px",
        }}
        id="ellbyuvluh20s"
        className="animable"
      />
      <path
        d="M153.08,113.26a4.29,4.29,0,0,1,1.57-1.25h-.13a2,2,0,0,1,.35-.09,1.65,1.65,0,0,1,1.31,0h0a3.09,3.09,0,0,1,1.81,1.31,3.64,3.64,0,0,1-.09,3.79,2.79,2.79,0,0,1-5.19-.5A3.46,3.46,0,0,1,153.08,113.26Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "155.47px 115.178px 0px",
        }}
        id="el46843otnz05"
        className="animable"
      />
      <path
        d="M156.82,114.58a.45.45,0,0,1,0,.11.94.94,0,0,1-.08.31,1.86,1.86,0,0,1-.88.91,5,5,0,0,1-2,.56,7.08,7.08,0,0,1-1.31,0,4.6,4.6,0,0,1-1.44-.33l.09,0a4,4,0,0,1-6.21,3l.14,0a1.67,1.67,0,0,1-1,.79,2.34,2.34,0,0,1-1.31,0,2.15,2.15,0,0,1-1.12-.78,2.89,2.89,0,0,1-.51-1.3,4.21,4.21,0,0,1,.68-2.76,12.61,12.61,0,0,1,2-2.23l0,.19a2.84,2.84,0,0,1-1.42-1.82,4.18,4.18,0,0,1,.05-2.4,6.31,6.31,0,0,1,1.27-2.12,18.61,18.61,0,0,1,1.79-1.76v.19a3.09,3.09,0,0,1-1-2.29,4.41,4.41,0,0,1,.74-2.47,10.86,10.86,0,0,1,3.73-3l-.05.14a5.38,5.38,0,0,1,5.34-7.05l-.12.15a4.67,4.67,0,0,1,.8-4,4.58,4.58,0,0,1,3.29-1.93l-.09.11a4.52,4.52,0,0,1,1.57-3.65,4.44,4.44,0,0,1,3.31-1.19L163,80a4.46,4.46,0,0,1,.51-2.12,5.6,5.6,0,0,1,1.11-1.57,4.68,4.68,0,0,1,2.68-1.4l.3,0h.28a4.27,4.27,0,0,1,.52,0,7.25,7.25,0,0,1,.79.16l.46.16.16.06s-.06,0-.17,0l-.46-.13a4.54,4.54,0,0,0-.79-.14,2.81,2.81,0,0,0-.51,0,2.61,2.61,0,0,0-.28,0l-.29,0a4.52,4.52,0,0,0-2.6,1.4,5.72,5.72,0,0,0-1.08,1.54,4.48,4.48,0,0,0-.47,2V80h-.09a4.28,4.28,0,0,0-3.18,1.16,4.35,4.35,0,0,0-1.49,3.5v.11h-.1a4.37,4.37,0,0,0-3.13,1.86,4.43,4.43,0,0,0-.76,3.81l.05.16h-.16a5.13,5.13,0,0,0-5.1,6.74l0,.1-.08,0a10.62,10.62,0,0,0-3.66,3,4.15,4.15,0,0,0-.69,2.33,2.78,2.78,0,0,0,.88,2.1l.11.09-.11.09a9.54,9.54,0,0,0-3,3.77,4,4,0,0,0-.06,2.26,2.65,2.65,0,0,0,1.3,1.68l.15.07L144,113a12.06,12.06,0,0,0-2,2.18,3.93,3.93,0,0,0-.66,2.61,2.16,2.16,0,0,0,1.47,1.91A1.77,1.77,0,0,0,145,119l.05-.09.09.06a3.92,3.92,0,0,0,4.09.09,4,4,0,0,0,1.88-3V116l.08,0a4.9,4.9,0,0,0,1.4.33,6.94,6.94,0,0,0,1.29,0,4.93,4.93,0,0,0,1.94-.52,1.83,1.83,0,0,0,.87-.86C156.79,114.73,156.8,114.58,156.82,114.58Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "155.489px 97.4628px 0px",
        }}
        id="el6njtj5oyy44"
        className="animable"
      />
      <path
        d="M125.42,108.19a3.36,3.36,0,0,1-.34-.47,4.3,4.3,0,0,1-.55-1.57,4.09,4.09,0,0,1,.48-2.58,4.32,4.32,0,0,1,2.79-2.08l-.06.11a5.52,5.52,0,0,1,.44-4,5.3,5.3,0,0,1,1.45-1.8,13.09,13.09,0,0,1,2.14-1.2,4.39,4.39,0,0,0,1-.71,2.57,2.57,0,0,0,.66-1c.31-.8.35-1.73.75-2.59a4.91,4.91,0,0,1,4.74-2.8l-.13.14a6.49,6.49,0,0,1,6.63-7.86l-.13.15a5.7,5.7,0,0,1,8.45-6l-.13,0a7.79,7.79,0,0,1,2.7-1.93,11.9,11.9,0,0,1,2.85-.87,13.63,13.63,0,0,1,4.81,0,9.62,9.62,0,0,1,2.93,1,6.39,6.39,0,0,1,.69.43l.23.16s-.32-.2-1-.53A10,10,0,0,0,164,71.2a13.45,13.45,0,0,0-4.76.07,11.9,11.9,0,0,0-2.8.88,7.72,7.72,0,0,0-2.62,1.9l-.06.06-.07,0a5.65,5.65,0,0,0-5.62.11,5.59,5.59,0,0,0-2.49,5.62l0,.15h-.15A6.24,6.24,0,0,0,139,87.51l0,.16h-.16a4.68,4.68,0,0,0-4.51,2.65c-.38.81-.43,1.73-.75,2.58a3,3,0,0,1-.72,1.12,4.71,4.71,0,0,1-1.06.74,12.13,12.13,0,0,0-2.11,1.17,5.18,5.18,0,0,0-1.41,1.73,5.41,5.41,0,0,0-.46,3.9l0,.09h-.09a4.19,4.19,0,0,0-2.71,2,4.1,4.1,0,0,0-.5,2.51,4.37,4.37,0,0,0,.5,1.56C125.3,108,125.43,108.18,125.42,108.19Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "146.154px 89.5531px 0px",
        }}
        id="ellx6gc44pgob"
        className="animable"
      />
      <path
        d="M202.82,104.74a.82.82,0,0,1-.08-.65,1.56,1.56,0,0,1,.43-.71,2.55,2.55,0,0,1,1-.57,5.2,5.2,0,0,0,1.22-.62,2.5,2.5,0,0,0,.81-1.36,4.83,4.83,0,0,0,.07-1.87c-.07-.66-.23-1.36-.29-2.12a22.26,22.26,0,0,1,.68-4.85,6.65,6.65,0,0,0-.08-2.66,3.25,3.25,0,0,0-1.63-2.16,12,12,0,0,0-2.9-.76,4.71,4.71,0,0,1-1.5-.56,3.31,3.31,0,0,1-1.11-1.21,16.16,16.16,0,0,1-1.09-3.11,5.34,5.34,0,0,0-.67-1.5,2.44,2.44,0,0,0-1.26-1,8.9,8.9,0,0,0-2.26-.14,3.49,3.49,0,0,1-1.15-.21,2.25,2.25,0,0,1-.95-.68,8,8,0,0,1-1-2,5,5,0,0,0-4.78-3.17,5,5,0,0,0-3.34,1.49l-.1.11-.07-.13a7.7,7.7,0,0,0-5.1-3.79,7.09,7.09,0,0,0-2.71,0,6.53,6.53,0,0,0-2.18.78,5.72,5.72,0,0,0-2.2,2.34,4.73,4.73,0,0,0-.34.79l-.09.21s0,.07,0,.06a.23.23,0,0,1,0-.07l.06-.21a5.24,5.24,0,0,1,.32-.81,5.68,5.68,0,0,1,2.2-2.42,6.64,6.64,0,0,1,2.21-.82,7.23,7.23,0,0,1,2.78,0,7.88,7.88,0,0,1,5.25,3.86l-.17,0a5.23,5.23,0,0,1,3.48-1.57A5.14,5.14,0,0,1,190,74.13,5.23,5.23,0,0,1,191.25,76a7.32,7.32,0,0,0,1,1.94,2.37,2.37,0,0,0,1.92.8,9.21,9.21,0,0,1,2.32.15,2.79,2.79,0,0,1,1.4,1,6,6,0,0,1,.7,1.56,14.61,14.61,0,0,0,1.06,3.07,2.92,2.92,0,0,0,1,1.12,4.44,4.44,0,0,0,1.42.54A11.91,11.91,0,0,1,205,87a3.09,3.09,0,0,1,1.14,1,4,4,0,0,1,.6,1.33,7.1,7.1,0,0,1,.08,2.75,21.29,21.29,0,0,0-.71,4.8c0,.74.2,1.44.27,2.11a5.08,5.08,0,0,1-.09,1.92,2.57,2.57,0,0,1-.88,1.42,4.89,4.89,0,0,1-1.26.62,2.7,2.7,0,0,0-.94.53,1.55,1.55,0,0,0-.43.67A1,1,0,0,0,202.82,104.74Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "188.532px 87.4826px 0px",
        }}
        id="elaozwkjp84di"
        className="animable"
      />
      <path
        d="M217.59,91.09s0,0-.1-.14-.15-.25-.25-.44l-1-1.69c-.42-.73-.9-1.65-1.56-2.64a7.12,7.12,0,0,0-2.92-2.7c-.68-.31-1.45-.49-2.23-.77a5.2,5.2,0,0,1-1.16-.57,2.86,2.86,0,0,1-.9-1c-.44-.81-.52-1.76-.89-2.6a2.27,2.27,0,0,0-.86-1,4.24,4.24,0,0,0-1.34-.51,8.21,8.21,0,0,1-1.47-.44,2.58,2.58,0,0,1-1.18-1.06,11.47,11.47,0,0,1-.92-3.09A3.92,3.92,0,0,0,200.2,71a2,2,0,0,0-1.34-.75c-1.08-.14-2.19.31-3.39.21a2.79,2.79,0,0,1-1.61-.71,7.15,7.15,0,0,1-1.11-1.31,13.5,13.5,0,0,0-1-1.33,3,3,0,0,0-1.26-.93,4.73,4.73,0,0,0-3.05.25,7.3,7.3,0,0,1-3,.49,8.46,8.46,0,0,1-2.76-1,13.37,13.37,0,0,0-2.47-1.15,8.35,8.35,0,0,0-4.8.19A9,9,0,0,0,171,67a10.1,10.1,0,0,0-1.79,2.46,11,11,0,0,0-.71,1.8l-.15.48-.06.17s0-.06,0-.17l.13-.49a10.42,10.42,0,0,1,.68-1.83,9.82,9.82,0,0,1,1.77-2.52,9.17,9.17,0,0,1,3.46-2.15,8.56,8.56,0,0,1,4.92-.23,14.21,14.21,0,0,1,2.52,1.15,7.87,7.87,0,0,0,2.68,1,7,7,0,0,0,2.95-.49,11,11,0,0,1,1.55-.39,3.32,3.32,0,0,1,1.65.14,3.37,3.37,0,0,1,1.36,1,14.24,14.24,0,0,1,1,1.34A6.93,6.93,0,0,0,194,69.53a2.66,2.66,0,0,0,1.47.65c1.12.1,2.23-.36,3.4-.21a2.26,2.26,0,0,1,1.5.84,4.14,4.14,0,0,1,.69,1.53,11.88,11.88,0,0,0,.89,3,2.36,2.36,0,0,0,1.08,1,7.63,7.63,0,0,0,1.43.43,4.42,4.42,0,0,1,1.4.54,2.56,2.56,0,0,1,.94,1.15c.38.89.46,1.83.87,2.59a3.3,3.3,0,0,0,1.94,1.48c.77.28,1.54.47,2.24.79a7.34,7.34,0,0,1,3,2.78c.66,1,1.12,1.94,1.53,2.68l.92,1.71c.1.19.18.33.23.45A1.21,1.21,0,0,1,217.59,91.09Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "192.94px 77.6771px 0px",
        }}
        id="ellojqzoy55km"
        className="animable"
      />
      <path
        d="M208.37,83.27l.15,0a1,1,0,0,1,.44.07,1.72,1.72,0,0,1,.9,1.37,4,4,0,0,1-.08,1.22,5,5,0,0,0-.11,1.41,3.11,3.11,0,0,0,.68,1.45c.35.47.78.92,1.15,1.47a2.34,2.34,0,0,1,.35,2c-.21.71-.67,1.32-.86,2a3,3,0,0,0,.38,2.2c.37.72.87,1.4,1.24,2.2A3.69,3.69,0,0,1,213,100a3.34,3.34,0,0,1-.21,1.36,15.92,15.92,0,0,1-1.37,2.41,3.76,3.76,0,0,0-.67,2.62A12.67,12.67,0,0,0,211.9,109a4.36,4.36,0,0,1,.41,1.46A3.39,3.39,0,0,1,212,112a12.7,12.7,0,0,1-1.58,2.41,6.54,6.54,0,0,0-1.25,2.39,18.73,18.73,0,0,1-.65,2.58,3,3,0,0,1-.74,1.08,3.73,3.73,0,0,1-1.11.63c-.38.16-.75.3-1.09.48a3.81,3.81,0,0,0-.88.71,8.42,8.42,0,0,0-1.2,1.82c-.33.63-.63,1.25-1,1.81a5.54,5.54,0,0,1-2.66,2.27,6,6,0,0,1-2.62.45,5.15,5.15,0,0,1-1.64-.36,3.22,3.22,0,0,1-.53-.25,5.87,5.87,0,0,0,4.74,0,5.38,5.38,0,0,0,2.56-2.24c.34-.55.64-1.16,1-1.8a8.21,8.21,0,0,1,1.22-1.87,4,4,0,0,1,.93-.75,11.06,11.06,0,0,1,1.11-.5,3.49,3.49,0,0,0,1-.6,2.62,2.62,0,0,0,.68-1,20.65,20.65,0,0,0,.64-2.55,6.71,6.71,0,0,1,1.28-2.47,12.59,12.59,0,0,0,1.54-2.36,3.11,3.11,0,0,0,.25-1.38,4,4,0,0,0-.38-1.37,12,12,0,0,1-1.2-2.71,3.08,3.08,0,0,1,.09-1.48,6.53,6.53,0,0,1,.61-1.31,15.47,15.47,0,0,0,1.36-2.37,3.23,3.23,0,0,0,.2-1.26,3.42,3.42,0,0,0-.34-1.22c-.35-.77-.84-1.45-1.22-2.19a3.23,3.23,0,0,1-.39-2.36c.22-.77.68-1.37.88-2a2.18,2.18,0,0,0-.32-1.88c-.34-.53-.77-1-1.12-1.46a3.2,3.2,0,0,1-.69-1.53,5.14,5.14,0,0,1,.12-1.45,4.25,4.25,0,0,0,.11-1.19,1.71,1.71,0,0,0-.83-1.34A1,1,0,0,0,208.37,83.27Z"
        style={{
          fill: "rgb(69, 90, 100)",
          transformOrigin: "204.027px 105.953px 0px",
        }}
        id="elbgek2ms6so"
        className="animable"
      />
      <path
        d="M125.6,107.91a2.82,2.82,0,0,1-.64,0,4.44,4.44,0,0,1-3.64-2.86,4.58,4.58,0,0,1,.38-3.86,11.63,11.63,0,0,1,1.49-1.78,5.49,5.49,0,0,0,1.37-2,3.56,3.56,0,0,0-.31-2.56c-.38-.84-.91-1.65-1.28-2.59a7.95,7.95,0,0,1,5.22-10.53l-.06.2a4,4,0,0,1-.83-1.71,5.22,5.22,0,0,1,0-1.93A5.6,5.6,0,0,1,128,76.4a6.38,6.38,0,0,1,1.27-1.52,12.51,12.51,0,0,1,5.15-2.54,18.83,18.83,0,0,1,5.41-.64l-.12.12a5.77,5.77,0,0,1,2.88-5.21,5.84,5.84,0,0,1,2.8-.75,9.5,9.5,0,0,1,2.7.5,5.06,5.06,0,0,0,1.26.19,3.29,3.29,0,0,0,1.21-.22,9.71,9.71,0,0,0,2.06-1.19,8.35,8.35,0,0,1,2-1.09,7.17,7.17,0,0,1,2-.43,6.93,6.93,0,0,1,3.43.67,7.07,7.07,0,0,1,2.09,1.56,6.82,6.82,0,0,1,.95,1.33,3,3,0,0,1,.24.51s-.09-.18-.28-.49a7.1,7.1,0,0,0-1-1.3,7.18,7.18,0,0,0-2.09-1.51,6.79,6.79,0,0,0-3.36-.62,7.12,7.12,0,0,0-2,.43,9.06,9.06,0,0,0-1.93,1.08,9.75,9.75,0,0,1-2.09,1.23,3.43,3.43,0,0,1-1.28.24,5.33,5.33,0,0,1-1.31-.2,9.53,9.53,0,0,0-2.65-.48,5.64,5.64,0,0,0-2.69.74,5.52,5.52,0,0,0-2.75,5v.13h-.13a19.1,19.1,0,0,0-5.35.64,12.34,12.34,0,0,0-5.05,2.49,6.37,6.37,0,0,0-1.22,1.47,5.27,5.27,0,0,0-.64,1.75,4.69,4.69,0,0,0,0,1.83,3.84,3.84,0,0,0,.78,1.61l.12.15-.18,0a7.72,7.72,0,0,0-5.08,10.22c.35.91.88,1.72,1.26,2.58a3.78,3.78,0,0,1,.31,2.69,5.5,5.5,0,0,1-1.42,2.1,11.13,11.13,0,0,0-1.48,1.74,4.43,4.43,0,0,0-.4,3.74,4.18,4.18,0,0,0,1.81,2.22,4.52,4.52,0,0,0,1.71.64C125.38,107.91,125.6,107.89,125.6,107.91Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "142.195px 85.7675px 0px",
        }}
        id="eli2j3ren3hl"
        className="animable"
      />
      <path
        d="M210.81,77.51a.63.63,0,0,1,0-.16c0-.11-.05-.26-.08-.45-.07-.41-.17-1-.29-1.73s-.31-1.66-.59-2.71a15.84,15.84,0,0,0-1.33-3.4,10.34,10.34,0,0,0-2.84-3.35,7.78,7.78,0,0,0-2.16-1.13,22,22,0,0,0-2.57-.53,7.26,7.26,0,0,1-2.63-.95,11.59,11.59,0,0,1-2.21-1.89c-.68-.71-1.33-1.46-2.08-2.13a8.1,8.1,0,0,0-2.56-1.61,14.43,14.43,0,0,0-5.93-.81,38,38,0,0,0-5.6.64A28.85,28.85,0,0,0,171,60.52a20.54,20.54,0,0,0-5,4c-.25.29-.48.53-.67.76s-.32.43-.45.59l-.27.37c-.07.08-.1.12-.11.11l.08-.13c.07-.09.16-.22.26-.38l.43-.6c.18-.24.41-.49.65-.78a20,20,0,0,1,5-4.1,28.62,28.62,0,0,1,9-3.29,38.38,38.38,0,0,1,5.63-.67,14.84,14.84,0,0,1,6,.83,8.31,8.31,0,0,1,2.63,1.65c.76.69,1.42,1.45,2.1,2.15a11.1,11.1,0,0,0,2.16,1.86,6.93,6.93,0,0,0,2.55.92,21.05,21.05,0,0,1,2.58.56,7.87,7.87,0,0,1,2.23,1.16A10.59,10.59,0,0,1,208.64,69,16,16,0,0,1,210,72.43c.27,1,.43,2,.55,2.73s.2,1.34.25,1.74c0,.19,0,.34.05.45S210.81,77.51,210.81,77.51Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "187.683px 66.9378px 0px",
        }}
        id="ely120jb1kxhd"
        className="animable"
      />
      <path
        d="M193.75,127.09l-1,.87c1.28,6.54-4.13,15-6.65,18.47l.79.61C189.46,143.31,195.13,134.14,193.75,127.09Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "190.032px 137.065px 0px",
        }}
        id="elr7458q0fuh8"
        className="animable"
      />
      <path
        d="M193.75,127.09a2.59,2.59,0,0,1,.08.41,9.86,9.86,0,0,1,.17,1.27,16.34,16.34,0,0,1-.43,4.61c-.84,3.83-3.16,8.83-6.6,13.75l-.09.14-.13-.11-.33-.26-.45-.35-.12-.09.09-.13a42.5,42.5,0,0,0,5.86-10.89,15.37,15.37,0,0,0,.86-7.47v0l0,0,.82-.64.25-.19-.26.25-.74.66,0,0a14.84,14.84,0,0,1-.73,7.57,41.28,41.28,0,0,1-5.85,11l0-.22.45.36.33.26-.22,0a42.42,42.42,0,0,0,6.63-13.62,17.09,17.09,0,0,0,.53-4.55c0-.55-.08-.93-.09-1.23S193.75,127.1,193.75,127.09Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "189.935px 137.18px 0px",
        }}
        id="el4f8wwy96lwn"
        className="animable"
      />
      <path
        d="M154.92,120.58c-2.23-4.86-.31-8.21.54-9.35a3.13,3.13,0,0,0,1.1.23,1.76,1.76,0,0,0,1.23-.79,1.79,1.79,0,0,0,.34-1.14,3.25,3.25,0,0,0-1.21-2.47,1.47,1.47,0,0,0-2.53.71,2.81,2.81,0,0,0,.3,2.84c-1,1.3-3.11,5.09-.68,10.39,3,6.42,12.89,24.53,15.16,26.49l.73-.74C167.86,145,158,127.28,154.92,120.58Z"
        style={{
          fill: "rgb(224, 224, 224)",
          transformOrigin: "161.392px 127.035px 0px",
        }}
        id="elofh6ho6ku6r"
        className="animable"
      />
      <path
        d="M154.92,120.58s.1.17.27.51l.74,1.48c.64,1.29,1.62,3.16,2.89,5.51s2.81,5.16,4.64,8.34q1.36,2.39,2.95,5c.53.87,1.08,1.75,1.66,2.64a18.78,18.78,0,0,0,1.92,2.58l.11.11-.1.1-.73.75-.1.1-.1-.1a20.41,20.41,0,0,1-2.35-3.16c-.72-1.12-1.43-2.28-2.13-3.46-1.41-2.38-2.82-4.86-4.23-7.41-2.21-4-4.31-8-6.13-11.75a12.29,12.29,0,0,1-1.47-5.93,9.64,9.64,0,0,1,1.83-5.36v.16a2.56,2.56,0,0,1-.56-1.81,3.45,3.45,0,0,1,.56-1.75,1.45,1.45,0,0,1,.73-.58,1.49,1.49,0,0,1,.91,0,2.69,2.69,0,0,1,1.35,1,3.37,3.37,0,0,1,.62,1.49,2.08,2.08,0,0,1-1.4,2.45,2.6,2.6,0,0,1-1.37-.21l.11,0a8.2,8.2,0,0,0-1.52,3.78,9.58,9.58,0,0,0,.13,3.06,11.14,11.14,0,0,0,.54,1.83c.16.41.23.62.23.62s-.1-.2-.28-.6a11,11,0,0,1-.59-1.83,9.32,9.32,0,0,1-.18-3.09,8.36,8.36,0,0,1,1.52-3.88l0-.06.06,0a2.56,2.56,0,0,0,1.27.2,2.13,2.13,0,0,0,1-.84,2.73,2.73,0,0,0-.4-2.78,2.52,2.52,0,0,0-1.23-.93,1.16,1.16,0,0,0-1.37.48,2.83,2.83,0,0,0,0,3.25l.06.08-.06.09a9.37,9.37,0,0,0-1.75,5.21,12.07,12.07,0,0,0,1.45,5.79c1.82,3.78,3.92,7.7,6.13,11.73,1.41,2.55,2.82,5,4.22,7.4.7,1.18,1.41,2.34,2.13,3.46a19.86,19.86,0,0,0,2.28,3.1h-.2l.74-.74v.21a18.19,18.19,0,0,1-2-2.64c-.58-.9-1.14-1.79-1.66-2.66-1.05-1.75-2-3.43-2.93-5-1.81-3.19-3.35-6-4.59-8.38s-2.2-4.25-2.82-5.55c-.32-.65-.54-1.16-.7-1.5S154.92,120.58,154.92,120.58Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "161.43px 127.089px 0px",
        }}
        id="el8na40pkp4f"
        className="animable"
      />
    </g>
    <defs>
      <filter id="active" height="200%">
        <feMorphology
          in="SourceAlpha"
          result="DILATED"
          operator="dilate"
          radius={2}
        />
        <feFlood floodColor="#32DFEC" floodOpacity={1} result="PINK" />
        <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
        <feMerge>
          <feMergeNode in="OUTLINE" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <filter id="hover" height="200%">
        <feMorphology
          in="SourceAlpha"
          result="DILATED"
          operator="dilate"
          radius={2}
        />
        <feFlood floodColor="#ff0000" floodOpacity={0.5} result="PINK" />
        <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
        <feMerge>
          <feMergeNode in="OUTLINE" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
        <feColorMatrix
          type="matrix"
          values="0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
        />
      </filter>
    </defs>
  </svg>
)
export default MyAssignedDevicesCountAnimated
